import axios from "axios";
import GroundingToggle from "./components/GroundingToggle";
import apiClient from "./api/config";
import React, { useEffect, useState, useRef } from "react";
import {
  FiUpload,
  FiRefreshCw,
  FiSend,
  FiXCircle,
  FiUploadCloud,
  FiCopy,
  FiFlag,
  FiEdit3,
  FiCheck,
  FiX,
  FiClock,
  FiFacebook,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from "react-spinners";
import { getDatabase, ref, get, update, set, push, onValue } from "firebase/database";
import SchedulePostModal from "./components/SchedulePostModal";
import ScheduledPostsList from "./components/ScheduledPostsList";
import PointWarning from "./components/PointWarning";
import {
  POST_LENGTHS,
  POST_STYLES,
  DEFAULT_POST_LENGTH,
  DEFAULT_POST_STYLES,
} from "./constants/postSettings";
import ImageSourceSelector from "./components/ImageSourceSelector";
import PostLanguageSelector from "./components/PostLanguageSelector";
import { SUPPORTED_LANGUAGES, getLanguageName } from "./constants/languages";
import { withValidToken } from "./services/tokenService";
import ReconnectFanpageModal from "./components/ReconnectFanpageModal";
import { sendPostReportNotification } from "./utils/telegramNotification";
import {
  IMAGE_STYLE_OPTIONS,
  DEFAULT_IMAGE_STYLE,
  ASPECT_RATIO_OPTIONS,
  DEFAULT_ASPECT_RATIO,
} from "./services/aiImageService";
import { normalizeGeneratedPostPayload } from "./utils/generatedPostParser";
import { publishZaloPost } from "./services/zaloService";
import {
  getSocialAccountKey,
  hasZaloAccount,
  loadConnectedSocialAccounts,
  toLegacyFacebookFanpagePayload,
  toSelectedAccountPayload,
} from "./utils/socialChannels";

const AI_IMAGE_JOB_TIMEOUT_MS = 150000;
const AI_IMAGE_CREATE_JOB_TIMEOUT_MS = 15000;

const NormalPostGenerator = () => {
  const [requirements, setRequirements] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  const [allowNoImage, setAllowNoImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [generatedPost, setGeneratedPost] = useState(null);
  const [selectedFanpage, setSelectedFanpage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fanpages, setFanpages] = useState([]);
  const [userAccessToken, setUserAccessToken] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [suggestedTopics, setSuggestedTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState("");
  const [isGeneratingPost, setIsGeneratingPost] = useState(false);
  const [isSuggestingTopics, setIsSuggestingTopics] = useState(false);
  const [postLength, setPostLength] = useState(DEFAULT_POST_LENGTH);
  const [postStyles, setPostStyles] = useState(DEFAULT_POST_STYLES);
  const [isRegeneratingPost, setIsRegeneratingPost] = useState(false);
  const [isRegeneratingImage, setIsRegeneratingImage] = useState(false);
  const [imageJobStatus, setImageJobStatus] = useState(null);
  const [imageJobProgress, setImageJobProgress] = useState(0);
  const [imageJobMessage, setImageJobMessage] = useState("");
  const [selectedFanpages, setSelectedFanpages] = useState([]);
  const [userPoints, setUserPoints] = useState(0);
  const [suggestedTopicInput, setSuggestedTopicInput] = useState("");
  const [serperImages, setSerperImages] = useState([]);
  const [selectedSerperImages, setSelectedSerperImages] = useState([]);
  const [useGeminiForImage, setUseGeminiForImage] = useState(false);
  const [geminiGeneratedImage, setGeminiGeneratedImage] = useState(null);
  const [postCount, setPostCount] = useState(0);
  const [postedCount, setPostedCount] = useState(0);
  const [includeContactInfo, setIncludeContactInfo] = useState(false);
  const [useGoogleSearch, setUseGoogleSearch] = useState(false); // Premium Grounding opt-in, default OFF
  const [previewImage, setPreviewImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageSource, setImageSource] = useState("internet");
  const [imageStyle, setImageStyle] = useState(DEFAULT_IMAGE_STYLE);
  const [aspectRatio, setAspectRatio] = useState(DEFAULT_ASPECT_RATIO);
  const [customImagePrompt, setCustomImagePrompt] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedPostText, setEditedPostText] = useState("");
  const [isStyleDropdownOpen, setIsStyleDropdownOpen] = useState(false);
  const styleDropdownRef = useRef(null);
  const [settings, setSettings] = useState({
    postLength: DEFAULT_POST_LENGTH,
    postStyles: DEFAULT_POST_STYLES,
    includeContactInfo: false,
    useGeminiForImage: false,
    imageSource: "internet",
    imageStyle: DEFAULT_IMAGE_STYLE,
    aspectRatio: DEFAULT_ASPECT_RATIO,
    customImagePrompt: "",
    useGoogleSearch: false, // Premium Grounding: opt-in, default OFF
  });
  const [postStatsService, setPostStatsService] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState("vi"); // Mặc định là tiếng Việt
  const navigate = useNavigate();
  const generatedPostRef = useRef(null);
  const aiImageJobUnsubscribeRef = useRef(null);
  const aiImageJobTimeoutRef = useRef(null);
  const dropdownRef = useRef(null);
  // Thêm state để theo dõi việc chỉnh sửa
  const [hasEdited, setHasEdited] = useState(false);
  // Thêm state cho modal kết nối lại fanpage
  const [showReconnectModal, setShowReconnectModal] = useState(false);
  const [reconnectFanpage, setReconnectFanpage] = useState(null);
  // Thêm state cho URL context
  const [inputUrls, setInputUrls] = useState("");
  const [isValidatingUrls, setIsValidatingUrls] = useState(false);
  const [urlValidationErrors, setUrlValidationErrors] = useState([]);
  const [validSerperImages, setValidSerperImages] = useState([]);
  const [userMembership, setUserMembership] = useState(null);

  // Platform selection for content generation
  const [contentPlatform, setContentPlatform] = useState("facebook");
  const [zaloArticle, setZaloArticle] = useState(null);

  // Filter accounts by selected content platform
  const filteredFanpages = fanpages.filter((fp) => {
    const fpPlatform = fp.platform || "facebook";
    return fpPlatform === contentPlatform;
  });

  // Report states
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportType, setReportType] = useState("");
  const [reportDescription, setReportDescription] = useState("");
  const [isSubmittingReport, setIsSubmittingReport] = useState(false);

  // Schedule post states
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [isScheduling, setIsScheduling] = useState(false);

  // Add initFacebookSDK function at component scope
  const initFacebookSDK = () => {
    return new Promise((resolve) => {
      if (window.FB) {
        resolve();
      } else {
        window.fbAsyncInit = () => {
          resolve();
        };
      }
    });
  };

  // Cập nhật lại 2 function cũ
  const fetchPostCount = async () => {
    if (!postStatsService) return;
    const count = await postStatsService.getGeneratedPostCount();
    setPostCount(count);
  };

  const fetchPostedCount = async () => {
    if (!postStatsService) return;
    const count = await postStatsService.getPostedCount();
    setPostedCount(count);
  };

  const incrementPostCount = async () => {
    if (!postStatsService) return;
    try {
      const newCount = await postStatsService.incrementGeneratedPostCount(
        postCount
      );
      setPostCount(newCount);
    } catch (error) {
      console.error("Error incrementing post count:", error);
    }
  };

  const incrementPostedCount = async () => {
    if (!postStatsService) return;
    try {
      const newCount = await postStatsService.incrementPostedCount(postedCount);
      setPostedCount(newCount);
    } catch (error) {
      console.error("Error incrementing posted count:", error);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("userAccessToken") == null) {
      navigate("/");
      return;
    }

    // Fetch user points from Firebase
    const fetchUserPoints = async () => {
      try {
        const db = getDatabase();
        const userId = localStorage.getItem("userId");
        const pointsRef = ref(db, `users/${userId}/points`);
        const snapshot = await get(pointsRef);

        if (snapshot.exists()) {
          const data = snapshot.val();
          if (data.points !== undefined && data.purchasedPoints !== undefined) {
            // Cấu trúc mới
            setUserPoints(data.points + data.purchasedPoints);
          } else if (typeof data.points === "number") {
            // Cấu trúc cũ
            setUserPoints(data.points);
          } else {
            console.error("Invalid points value:", data);
            setUserPoints(0);
          }
        } else {
          setUserPoints(0);
        }
      } catch (error) {
        console.error("Error fetching user points:", error);
        setUserPoints(0);
      }
    };

    // Gọi hàm fetchFanpages đã được định nghĩa ở trên

    fetchUserPoints();
    fetchFanpages();
    fetchPostCount();
    fetchPostedCount();
  }, [navigate]);

  // Lấy thông tin membership của user
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) return;
    const db = getDatabase();
    const membershipRef = ref(db, `/users/${userId}/membership`);
    const unsubscribe = onValue(membershipRef, (snapshot) => {
      if (snapshot.exists()) {
        setUserMembership(snapshot.val());
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (
        styleDropdownRef.current &&
        !styleDropdownRef.current.contains(event.target)
      ) {
        setIsStyleDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    return () => {
      if (aiImageJobUnsubscribeRef.current) {
        aiImageJobUnsubscribeRef.current();
        aiImageJobUnsubscribeRef.current = null;
      }
      if (aiImageJobTimeoutRef.current) {
        clearTimeout(aiImageJobTimeoutRef.current);
        aiImageJobTimeoutRef.current = null;
      }
    };
  }, []);

  // Keyboard shortcuts for better UX
  useEffect(() => {
    const handleKeyPress = (event) => {
      // Ctrl/Cmd + R để mở report modal (chỉ khi có bài viết)
      if (
        (event.ctrlKey || event.metaKey) &&
        event.key === "r" &&
        generatedPost
      ) {
        event.preventDefault();
        openReportModal();
      }
      // Escape để đóng modal
      if (event.key === "Escape" && showReportModal) {
        closeReportModal();
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [generatedPost, showReportModal]);

  const handlePostStyleChange = (style) => {
    const newStyles = postStyles.includes(style)
      ? postStyles.filter((s) => s !== style)
      : [...postStyles, style];
    setPostStyles(newStyles);
    const newSettings = {
      ...settings,
      postStyles: newStyles,
    };
    saveUserSettings(newSettings);
  };

  const checkPoints = () => {
    if (userPoints <= 0) {
      toast.error(
        "Bạn đã hết điểm! Vui lòng nạp thêm điểm để tiếp tục sử dụng dịch vụ.",
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
      return false;
    }
    return true;
  };

  const generatePost = async () => {
    // Kiểm tra nếu người dùng đã chỉnh sửa bài viết
    if (generatedPost && hasEdited) {
      if (
        !window.confirm(
          "Bạn đã chỉnh sửa bài viết. Tạo bài viết mới sẽ xóa các chỉnh sửa của bạn. Bạn có chắc chắn muốn tiếp tục?"
        )
      ) {
        return;
      }
    }

    if (!checkPoints()) return;

    // Validate URLs trước khi tạo bài viết
    const urlValidation = validateUrls(inputUrls);
    if (!urlValidation.isValid) {
      setUrlValidationErrors(urlValidation.errors);
      toast.error("Vui lòng sửa lỗi URL trước khi tạo bài viết!", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    // Kiểm tra phải có ít nhất requirements hoặc URL
    const hasRequirements = requirements && requirements.trim();
    const hasUrls = urlValidation.urls && urlValidation.urls.length > 0;

    if (!hasRequirements && !hasUrls) {
      toast.error("Vui lòng nhập yêu cầu bài viết HOẶC URL tham khảo!", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    // Debug log để kiểm tra URL validation
    console.log("URL Validation result:", urlValidation);

    // Xóa tất cả ảnh cũ
    setSelectedSerperImages([]);
    setSelectedImages([]);
    setGeminiGeneratedImage(null);
    setSerperImages([]);
    setPreviewImage(null);
    setIsEditMode(false); // Đảm bảo tắt chế độ sửa khi tạo bài viết mới
    setHasEdited(false); // Reset trạng thái đã chỉnh sửa

    // Đặt imageSource về nguồn đã chọn hoặc 'none' nếu text-only
    const currentImageSource = allowNoImage ? "none" : imageSource;

    // Chuẩn bị tham số cho API
    const options = {
      requirements: requirements,
      postLength: postLength,
      postStyles: postStyles.join(", "),
      imageSource: "none", // Bắt đầu không có ảnh, sẽ xử lý riêng sau
      includeContactInfo: includeContactInfo,
      fanpageInfo: "",
      language: selectedLanguage, // Thêm thông tin ngôn ngữ
      customImagePrompt,
      urls: urlValidation.urls || [], // Thêm URLs đã được validate, đảm bảo luôn là array
      platform: contentPlatform, // Truyền platform để backend route đúng pipeline (facebook/zalo)
      useGrounding: useGoogleSearch === true, // Premium Grounding opt-in, default OFF
    };

    // Debug log để kiểm tra options
    console.log("API Request options:", options);

    setIsGeneratingPost(true);
    const userId = localStorage.getItem("userId");

    try {
      // Gọi API tạo bài viết từ backend (chỉ tạo nội dung)
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/content/generate-post`,
        {
          options,
          userId,
        }
      );

      if (response.data.success) {
        let nextPost = null;
        if (contentPlatform === "zalo" && response.data.data.zaloArticle) {
          const article = response.data.data.zaloArticle;
          setZaloArticle(article);
          const fullText = (article.bodyParagraphs || []).join("\n\n");
          nextPost = {
            text: fullText,
            image: "",
            title: article.title || fullText,
          };
          setGeneratedPost(nextPost);
          setEditedPostText(fullText);
        } else {
          const { title, content, imagePrompt } = normalizeGeneratedPostPayload(
            response.data.data
          );
          setZaloArticle(null);
          nextPost = {
            text: content,
            image: "",
            title: title || content,
            ...(imagePrompt && { imagePrompt }),
          };
          setGeneratedPost(nextPost);
          setEditedPostText(content);
        }

        // Xử lý ảnh chỉ khi không phải là bài viết text-only
        if (!allowNoImage) {
          const imageSearchQuery = nextPost?.title || requirements || "";
          if (currentImageSource === "internet") {
            // Nếu nguồn ảnh là internet, gọi API lấy ảnh từ Serper
            await fetchImagesFromSerper(imageSearchQuery);
          } else if (currentImageSource === "ai") {
            // Nếu nguồn ảnh là AI, gọi API tạo ảnh bằng Gemini
            await generateGeminiImage(imageSearchQuery, nextPost?.imagePrompt || "");
          }
          // Nếu là "upload" thì không làm gì ở đây, ảnh đã được xử lý riêng
        }

        // Cuộn xuống bài viết mới tạo
        setTimeout(() => {
          if (generatedPostRef.current) {
            generatedPostRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 100);
      } else {
        toast.error(
          response.data.message ||
            "Không thể tạo bài viết. Vui lòng thử lại sau.",
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
      }
    } catch (error) {
      console.error("Lỗi khi tạo bài viết:", error);
      toast.error("Đã xảy ra lỗi khi tạo bài viết. Vui lòng thử lại sau.", {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsGeneratingPost(false);
    }
  };

  // Hàm riêng để lấy ảnh từ Hybrid System (Cheerio + Serper fallback)
  const fetchImagesFromSerper = async (queryText) => {
    const userId = localStorage.getItem("userId");
    setIsRegeneratingImage(true);
    try {
      // Sử dụng API mới với hybrid system
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/content/get-images-hybrid`,
        {
          query: queryText,
          userId,
          limit: 10, // Lấy nhiều ảnh hơn để có lựa chọn
        }
      );

      if (response.data.success) {
        const images = response.data.data.images || [];
        setSerperImages(images);

        // Log thông tin về nguồn ảnh và chi phí
        console.log(
          `🖼️ Images fetched from ${response.data.data.source} - Cost: ${response.data.data.pointsUsed} points`
        );

        // Chọn ảnh đầu tiên nếu có
        if (images.length > 0) {
          const firstImage = images[0].imageUrl;
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            image: firstImage,
          }));
        }
      } else {
        toast.warning("Không thể lấy ảnh. Vui lòng thử lại sau.", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error("Lỗi khi lấy ảnh:", error);

      // Thử fallback về API cũ nếu API mới không hoạt động
      if (error.response?.status === 404) {
        console.log("🔄 Fallback to legacy API...");
        try {
          const fallbackResponse = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/content/get-images-from-serper`,
            {
              query: queryText,
              userId,
            }
          );

          if (fallbackResponse.data.success) {
            const images = fallbackResponse.data.data.images || [];
            setSerperImages(images);

            toast.info("Đã lấy ảnh từ Serper API (legacy mode)", {
              position: "top-right",
              autoClose: 3000,
            });

            if (images.length > 0) {
              const firstImage = images[0].imageUrl;
              setGeneratedPost((prevPost) => ({
                ...prevPost,
                image: firstImage,
              }));
            }
            return;
          }
        } catch (fallbackError) {
          console.error("Fallback API also failed:", fallbackError);
        }
      }

      toast.error("Đã xảy ra lỗi khi lấy ảnh. Vui lòng thử lại sau.", {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsRegeneratingImage(false);
    }
  };

  const stopListeningAiImageJob = () => {
    if (aiImageJobUnsubscribeRef.current) {
      aiImageJobUnsubscribeRef.current();
      aiImageJobUnsubscribeRef.current = null;
    }
    if (aiImageJobTimeoutRef.current) {
      clearTimeout(aiImageJobTimeoutRef.current);
      aiImageJobTimeoutRef.current = null;
    }
  };

  const waitForGeminiImageJob = (jobId) => {
    stopListeningAiImageJob();

    return new Promise((resolve, reject) => {
      const db = getDatabase();
      const jobRef = ref(db, `jobs/${jobId}`);
      let settled = false;

      const settle = (callback, value) => {
        if (settled) return;
        settled = true;
        stopListeningAiImageJob();
        callback(value);
      };

      aiImageJobTimeoutRef.current = setTimeout(() => {
        settle(
          reject,
          new Error("Tạo ảnh AI quá lâu. Vui lòng thử lại sau ít phút.")
        );
      }, AI_IMAGE_JOB_TIMEOUT_MS);

      aiImageJobUnsubscribeRef.current = onValue(
        jobRef,
        (snapshot) => {
          const jobData = snapshot.val();
          if (!jobData) return;

          setImageJobStatus(jobData.status || "pending");
          setImageJobProgress(jobData.progress || 0);
          setImageJobMessage(jobData.progressMessage || "Đang tạo ảnh AI...");

          if (jobData.status === "completed") {
            const imageUrl = jobData.result?.imageUrl;
            if (!imageUrl) {
              settle(
                reject,
                new Error("Job tạo ảnh AI hoàn tất nhưng thiếu URL ảnh.")
              );
              return;
            }
            settle(resolve, jobData.result);
          } else if (jobData.status === "failed") {
            const errorMessage =
              typeof jobData.error === "string"
                ? jobData.error
                : jobData.error?.message || "Tạo ảnh AI thất bại.";
            settle(reject, new Error(errorMessage));
          }
        },
        (error) => {
          settle(reject, error);
        }
      );
    });
  };

  // Hàm riêng để tạo ảnh bằng Gemini
  const generateGeminiImage = async (promptText, preparedImagePromptEnglish = "") => {
    const userId = localStorage.getItem("userId");
    setIsRegeneratingImage(true);
    setImageJobStatus("pending");
    setImageJobProgress(0);
    setImageJobMessage("Đang gửi yêu cầu tạo ảnh AI...");
    try {
      console.log("📸 AI Image request metadata:", {
        promptLength: (promptText || "").length,
        preparedPromptAvailable: Boolean(preparedImagePromptEnglish),
      });

      const response = await apiClient.post(
        "/api/content/generate-image-with-gemini",
        {
          prompt: promptText,
          userId,
          imageSettings: {
            imageStyle,
            aspectRatio,
            customImagePrompt,
            preparedImagePromptEnglish,
            platform: contentPlatform,
          },
        },
        { timeout: AI_IMAGE_CREATE_JOB_TIMEOUT_MS }
      );

      if (response.data.success) {
        let imageUrl = response.data.data?.imageUrl;
        if (!imageUrl && response.data.data?.jobId) {
          const result = await waitForGeminiImageJob(response.data.data.jobId);
          imageUrl = result.imageUrl;
        }

        if (imageUrl) {
          setGeminiGeneratedImage(imageUrl);
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            image: imageUrl,
          }));
          return imageUrl;
        } else {
          toast.warning(
            "Không thể tạo ảnh với AI. Vui lòng thử lại hoặc sử dụng ảnh từ web.",
            {
              position: "top-right",
              autoClose: 5000,
            }
          );
        }
      } else {
        toast.warning(response.data.message || "Không thể tạo ảnh với AI. Vui lòng thử lại sau.", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error("Lỗi khi tạo ảnh bằng Gemini:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Đã xảy ra lỗi khi tạo ảnh. Vui lòng thử lại sau.";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsRegeneratingImage(false);
      setImageJobStatus(null);
      setImageJobProgress(0);
      setImageJobMessage("");
    }
  };

  const suggestTopics = () => {
    if (!checkPoints()) return;

    let info = "những chủ đề đang hot trên mạng xã hội facebook";

    if (requirements) {
      info = requirements;
    }

    if (info.trim().length > 8000) {
      toast.error(
        "Thông tin gợi ý chủ đề không được vượt quá 8000 ký tự. Vui lòng rút ngắn nội dung!",
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
      return;
    }

    setIsSuggestingTopics(true);
    apiClient
      .post("/api/content/suggest-topics", {
        userId: localStorage.getItem("userId"),
        source: "normal-post",
        info,
        language: selectedLanguage,
        topicCount: 10,
      })
      .then((response) => {
        const { data } = response;
        setSuggestedTopics(Array.isArray(data.topics) ? data.topics : []);
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          error?.response?.data?.message ||
            "Không thể gợi ý chủ đề. Vui lòng thử lại sau.",
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
      })
      .finally(() => {
        setIsSuggestingTopics(false);
      });
  };

  const clearSuggestedTopics = () => {
    setSuggestedTopics([]);
    setSelectedTopic("");
  };

  const handleTopicSelect = (topic) => {
    setSelectedTopic(topic);
    setRequirements(topic);
  };

  const regenerateImages = () => {
    if (!generatedPost) {
      toast.error("Vui lòng tạo bài viết trước khi tạo lại ảnh!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (hasEdited) {
      if (
        !window.confirm(
          "Tạo lại ảnh có thể ảnh hưởng đến nội dung bài viết đã chỉnh sửa. Bạn có chắc chắn muốn tiếp tục?"
        )
      ) {
        return;
      }
    }

    if (!checkPoints()) return;

    setIsRegeneratingImage(true);

    // Xử lý dựa trên nguồn ảnh
    if (imageSource === "internet") {
      // Nếu nguồn ảnh là internet, gọi API lấy ảnh từ Serper
      fetchImagesFromSerper(generatedPost.text).finally(() => {
        setIsRegeneratingImage(false);
      });
    } else if (imageSource === "ai") {
      // Nếu nguồn ảnh là AI, gọi API tạo ảnh bằng Gemini
      generateGeminiImage(
        generatedPost.title || generatedPost.text,
        generatedPost.imagePrompt || ""
      ).finally(() => {
        setIsRegeneratingImage(false);
      });
    } else if (imageSource === "upload") {
      // Nếu nguồn ảnh là upload, không làm gì cả
      setIsRegeneratingImage(false);
      toast.info(
        "Không thể tạo lại ảnh khi sử dụng ảnh từ thiết bị. Vui lòng tải lên ảnh mới.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } else {
      setIsRegeneratingImage(false);
    }
  };

  const savePostLink = async (fanpageId, postId) => {
    try {
      const db = getDatabase();
      const userId = localStorage.getItem("userId");
      const timestamp = Date.now(); // Lấy timestamp hiện tại
      const postLink = `https://www.facebook.com/${fanpageId}/posts/${postId}`;
      const formattedLink = `${timestamp}|${postLink}`; // Định dạng mới: timestamp|link
      const postType = "normalPostGenerator"; // Loại bài đăng
      const postLinksRef = ref(db, `users/${userId}/posts/${postType}/links`);

      // Lấy danh sách links hiện tại
      const snapshot = await get(postLinksRef);
      const currentLinks = snapshot.exists() ? snapshot.val() : [];

      // Thêm link mới vào đầu mảng
      const updatedLinks = [formattedLink, ...currentLinks];

      // Lưu lại vào database
      await set(postLinksRef, updatedLinks);
      try {
        const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";
        const token = localStorage.getItem("userAccessToken");
        await axios.post(
          `${apiUrl}/api/users/${userId}/post-link-index`,
          {
            postType,
            rawLink: formattedLink,
          },
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
      } catch (indexError) {
        console.warn("Error indexing post link:", indexError.message);
      }

      return true;
    } catch (error) {
      console.error("Error saving post link:", error);
      return false;
    }
  };

  const collectRawPostImages = () => {
    if (allowNoImage) return [];
    if (imageSource === "upload" && selectedImages.length > 0) {
      return selectedImages;
    }
    if (imageSource === "internet" && selectedSerperImages.length > 0) {
      return selectedSerperImages;
    }
    if (imageSource === "ai" && geminiGeneratedImage) {
      return [geminiGeneratedImage];
    }
    if (generatedPost?.images?.length > 0) {
      return generatedPost.images;
    }
    if (generatedPost?.image) {
      return [generatedPost.image];
    }
    return [];
  };

  const ensurePublicImageUrls = async (rawImages = []) => {
    const publicImages = [];

    for (const imgUrl of rawImages) {
      if (typeof imgUrl === "string" && /^https?:\/\//i.test(imgUrl)) {
        publicImages.push(imgUrl);
        continue;
      }

      if (typeof imgUrl === "string" && imgUrl.startsWith("data:")) {
        const formData = new FormData();
        formData.append("file", imgUrl);
        formData.append("upload_preset", "AutoWork");
        formData.append("api_key", "238276161954221");

        const response = await axios.post(
          "https://api.cloudinary.com/v1_1/test-upload-1/image/upload",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        publicImages.push(response.data.secure_url);
      }
    }

    return publicImages;
  };

  // Lấy danh sách fanpage từ Firebase (Firebase-first pattern)
  const fetchFanpages = async () => {
    try {
      const db = getDatabase();
      const userId = localStorage.getItem("userId");
      const socialAccounts = await loadConnectedSocialAccounts(db, userId);

      if (socialAccounts.length > 0) {
        console.log("Accounts được tải từ Firebase:", socialAccounts);
        setFanpages(socialAccounts);

        if (socialAccounts.length === 1) {
          setSelectedFanpage(socialAccounts[0]);
          setSelectedFanpages([socialAccounts[0]]);
        } else {
          setSelectedFanpage(null);
          setSelectedFanpages([]);
        }
      } else {
        console.error("Không tìm thấy account Facebook/Zalo trong Firebase");
      }
    } catch (error) {
      console.error("Lỗi khi tải account từ Firebase:", error);
      toast.error(
        "Có lỗi khi tải dữ liệu tài khoản đăng bài. Vui lòng thử lại sau!",
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
    }
  };

  // Hàm xử lý kết nối lại fanpage
  const handleReconnectFanpage = async () => {
    setShowReconnectModal(false);

    try {
      // Sử dụng service để kết nối lại fanpage
      const result = await import("./services/tokenService").then((module) =>
        module.reconnectFanpage(reconnectFanpage)
      );

      if (result.success) {
        toast.success(result.message, {
          position: "top-right",
          autoClose: 3000,
        });

        // Cập nhật lại danh sách fanpage
        await fetchFanpages();
      } else {
        toast.error(`Kết nối lại không thành công: ${result.error}`, {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error("Error reconnecting fanpage:", error);
      toast.error("Đã xảy ra lỗi khi kết nối lại fanpage", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  // Thêm hàm regeneratePost để tái tạo nội dung bài viết
  const regeneratePost = async () => {
    if (!checkPoints()) return;

    // Validate URLs trước khi tái tạo bài viết
    const urlValidation = validateUrls(inputUrls);
    if (!urlValidation.isValid) {
      setUrlValidationErrors(urlValidation.errors);
      toast.error("Vui lòng sửa lỗi URL trước khi tái tạo bài viết!", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    // Kiểm tra phải có ít nhất requirements hoặc URL
    const hasRequirements = requirements && requirements.trim();
    const hasUrls = urlValidation.urls && urlValidation.urls.length > 0;

    if (!hasRequirements && !hasUrls) {
      toast.error("Vui lòng nhập yêu cầu bài viết HOẶC URL tham khảo!", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    setIsRegeneratingPost(true);
    const userId = localStorage.getItem("userId");

    // Chuẩn bị tham số cho API
    const options = {
      requirements: requirements,
      postLength: postLength,
      postStyles: postStyles.join(", "),
      imageSource: "none", // Chỉ tái tạo nội dung
      includeContactInfo: includeContactInfo,
      fanpageInfo: "",
      language: selectedLanguage, // Thêm thông tin ngôn ngữ
      customImagePrompt,
      urls: urlValidation.urls || [], // Thêm URLs đã được validate, đảm bảo luôn là array
      platform: contentPlatform, // Truyền platform để backend route đúng pipeline (facebook/zalo)
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/content/generate-post`,
        {
          options,
          userId,
        }
      );

      if (response.data.success) {
        if (contentPlatform === "zalo" && response.data.data.zaloArticle) {
          const article = response.data.data.zaloArticle;
          setZaloArticle(article);
          const fullText = (article.bodyParagraphs || []).join("\n\n");
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            text: fullText,
            title: article.title || fullText,
          }));
          setEditedPostText(fullText);
        } else {
          const { title, content, imagePrompt } = normalizeGeneratedPostPayload(
            response.data.data
          );
          setZaloArticle(null);
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            text: content,
            title: title || content,
            ...(imagePrompt && { imagePrompt }),
          }));
          setEditedPostText(content);
        }

        // Đặt chế độ sửa về false
        setIsEditMode(false);

        toast.success("Đã tạo mới nội dung bài viết thành công!", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        toast.error(
          response.data.message ||
            "Không thể tái tạo bài viết. Vui lòng thử lại sau.",
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
      }
    } catch (error) {
      console.error("Lỗi khi tái tạo bài viết:", error);
      toast.error("Đã xảy ra lỗi khi tái tạo bài viết. Vui lòng thử lại sau.", {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsRegeneratingPost(false);
    }
  };

  const publishPost = async () => {
    if (selectedFanpages.length === 0) {
      toast.error("Vui lòng chọn ít nhất 1 fanpage để đăng bài!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    const userAccessToken = localStorage.getItem("userAccessToken");
    const currentUserId = localStorage.getItem("userId");
    const storedFanpages = JSON.parse(localStorage.getItem("fanpages") || "{}");
    const hasFacebookSelection = selectedFanpages.some(
      (account) => (account.platform || "facebook") === "facebook"
    );
    const hasZaloSelection = hasZaloAccount(selectedFanpages);

    if (!userAccessToken && hasFacebookSelection) {
      toast.error("Vui lòng đăng nhập vào Facebook trước!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    const rawImagesForPublish = collectRawPostImages();
    if (hasZaloSelection && rawImagesForPublish.length === 0) {
      toast.error("Zalo OA bắt buộc có ảnh cover. Vui lòng chọn hoặc tạo ảnh trước khi đăng.", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    setIsPublishing(true);

    // Thêm biến để theo dõi số lần thử
    let retryCount = 0;
    const maxRetries = 2;

    // Hàm thử lại việc đăng bài
    const tryPublishPost = async () => {
      try {
        if (hasFacebookSelection) {
          await initFacebookSDK();
        }
        let successCount = 0;
        const zaloImages = hasZaloSelection
          ? await ensurePublicImageUrls(rawImagesForPublish)
          : [];

        for (const fanpage of selectedFanpages) {
          try {
            if ((fanpage.platform || "facebook") === "zalo") {
              const zaloResult = await publishZaloPost({
                userId: currentUserId,
                account: fanpage,
                content: generatedPost.text,
                images: zaloImages,
                videos: [],
                generatorKey: "normalPostGenerator",
                zaloArticle: zaloArticle || undefined,
              });

              if (!zaloResult?.success) {
                throw new Error(
                  zaloResult?.result?.errorMessage ||
                    zaloResult?.message ||
                    "Zalo không trả về trạng thái thành công"
                );
              }

              successCount++;
              toast.success(`Đăng bài thành công lên ${fanpage.name}!`, {
                position: "top-right",
                autoClose: 3000,
              });
              continue;
            }

            // Sử dụng withValidToken để kiểm tra và làm mới token nếu cần
            console.log("📤 Bắt đầu withValidToken cho fanpage:", fanpage.name);
            await withValidToken(
              fanpage,
              async (updatedFanpage) => {
                // Sử dụng fanpage đã được cập nhật token
                const currentFanpage = updatedFanpage || fanpage;
                console.log("✅ Token hợp lệ, bắt đầu đăng bài lên:", currentFanpage.name);

                // Get fanpage info từ localStorage hoặc Firebase
                let fanpageInfo = storedFanpages[currentFanpage.id] || {};

                // Nếu không có thông tin từ localStorage, thử lấy từ Firebase
                if (!fanpageInfo.fanpageInfo) {
                  try {
                    const db = getDatabase();
                    const userId = localStorage.getItem("userId");
                    const fanpageInfoRef = ref(
                      db,
                      `users/${userId}/fanpages/${currentFanpage.id}`
                    );
                    const snapshot = await get(fanpageInfoRef);

                    if (snapshot.exists()) {
                      fanpageInfo = snapshot.val();
                    }
                  } catch (error) {
                    console.error(
                      "Không thể lấy thông tin fanpage từ Firebase:",
                      error
                    );
                  }
                }

                // Create footer with fanpage info
                let footerText = "";

                if (includeContactInfo && fanpageInfo.fanpageInfo) {
                  footerText = `

${fanpageInfo.fanpageInfo || ""}`;
                }

                // Combine post content with footer
                const fullPostContent = generatedPost.text + footerText;

                // Upload images only if not text-only post
                let attachedMedia = [];
                if (!allowNoImage) {
                  if (imageSource === "upload" && selectedImages.length > 0) {
                    // Nếu nguồn ảnh là upload và đã tải lên ảnh
                    for (const imgUrl of selectedImages) {
                      const photoId = await uploadImage(imgUrl, currentFanpage);
                      attachedMedia.push({ media_fbid: photoId });
                    }
                  } else if (
                    imageSource === "internet" &&
                    selectedSerperImages.length > 0
                  ) {
                    // Nếu nguồn ảnh là internet và đã chọn ảnh từ Serper
                    for (const imgUrl of selectedSerperImages) {
                      const photoId = await uploadImage(imgUrl, currentFanpage);
                      attachedMedia.push({ media_fbid: photoId });
                    }
                  } else if (imageSource === "ai" && geminiGeneratedImage) {
                    // Nếu nguồn ảnh là AI và đã tạo được ảnh từ Gemini
                    const photoId = await uploadImage(
                      geminiGeneratedImage,
                      currentFanpage
                    );
                    attachedMedia.push({ media_fbid: photoId });
                  } else if (
                    generatedPost.images &&
                    generatedPost.images.length > 0
                  ) {
                    // Nếu có mảng ảnh từ API
                    for (const imgUrl of generatedPost.images) {
                      const photoId = await uploadImage(imgUrl, currentFanpage);
                      attachedMedia.push({ media_fbid: photoId });
                    }
                  } else if (generatedPost.image) {
                    // Nếu không thuộc các trường hợp trên nhưng có ảnh trong bài viết
                    const photoId = await uploadImage(
                      generatedPost.image,
                      currentFanpage
                    );
                    attachedMedia.push({ media_fbid: photoId });
                  }
                }

                // Prepare post data
                const postData = {
                  message: fullPostContent,
                  access_token: currentFanpage.access_token,
                };

                // Add attached_media only if there are images and it's not a text-only post
                if (!allowNoImage && attachedMedia.length > 0) {
                  postData.attached_media = attachedMedia;
                }

                // Post to Facebook bằng axios (thay vì FB.api vì SDK hay treo khi không có session)
                console.log("📤 Gọi Graph API để đăng bài lên fanpage:", currentFanpage.id);
                const postResponse = await axios.post(
                  `https://graph.facebook.com/v21.0/${currentFanpage.id}/feed`,
                  postData,
                  { timeout: 30000 } // 30s timeout
                );

                if (postResponse.data && postResponse.data.id) {
                  console.log("✅ Đăng bài thành công, postId:", postResponse.data.id);
                  successCount++;
                  await savePostLink(currentFanpage.id, postResponse.data.id);
                } else {
                  throw new Error("Facebook không trả về post ID");
                }

                toast.success(
                  `Đăng bài thành công lên ${currentFanpage.name}!`,
                  {
                    position: "top-right",
                    autoClose: 3000,
                  }
                );
              },
              async (error) => {
                // Xử lý khi token không hợp lệ và không thể làm mới
                console.error(`Lỗi token cho fanpage ${fanpage.name}:`, error);

                // Hiển thị modal kết nối lại fanpage
                setReconnectFanpage(fanpage);
                setShowReconnectModal(true);

                toast.error(
                  `Không thể đăng bài lên ${fanpage.name}. Token không hợp lệ. Vui lòng kết nối lại fanpage.`,
                  {
                    position: "top-right",
                    autoClose: 5000,
                  }
                );
              }
            );
          } catch (error) {
            console.error(`Đăng bài thất bại lên ${fanpage.name}:`, error);

            // Nếu là lỗi khi đăng bài với ảnh AI và còn cơ hội thử lại
            if (imageSource === "ai" && retryCount < maxRetries) {
              retryCount++;
              await new Promise((resolve) => setTimeout(resolve, 2000)); // Đợi 2 giây
              return await tryPublishPost(); // Thử lại
            }

            toast.error(
              `Đăng bài thất bại lên ${fanpage.name}! ${error.message || ""}`,
              {
                position: "top-right",
                autoClose: 5000,
              }
            );
          }
        }

        // If at least one post was successful, increment the counter
        if (successCount > 0) {
          await incrementPostedCount();
        }
      } catch (error) {
        console.error("Failed to publish posts:", error);

        // Nếu là lỗi khi đăng bài với ảnh AI và còn cơ hội thử lại
        if (imageSource === "ai" && retryCount < maxRetries) {
          retryCount++;
          console.log(`Thử lại lần ${retryCount}/${maxRetries}...`);
          await new Promise((resolve) => setTimeout(resolve, 2000)); // Đợi 2 giây
          return await tryPublishPost(); // Thử lại
        }
      } finally {
        // Luôn đặt lại trạng thái - tránh treo mãi ở "Đang đăng bài"
        setIsPublishing(false);
      }
    };

    // Gọi hàm thử xuất bản
    await tryPublishPost();
  };

  const publishToProfile = async () => {
    const userAccessToken = localStorage.getItem("userAccessToken");

    if (!userAccessToken) {
      toast.error("Vui lòng đăng nhập vào Facebook trước!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setIsPublishing(true);

    // Thêm biến để theo dõi số lần thử
    let retryCount = 0;
    const maxRetries = 2;

    // Hàm thử lại việc đăng bài
    const tryPublishToProfile = async () => {
      try {
        await initFacebookSDK(); // Add this line before making FB API calls

        let attachedMedia = [];

        // Upload images only if not text-only post
        if (!allowNoImage) {
          if (imageSource === "internet" && selectedSerperImages.length > 0) {
            // Nếu nguồn ảnh là internet và đã chọn ảnh từ Serper
            for (const imgUrl of selectedSerperImages) {
              const photoId = await uploadImage(imgUrl);
              attachedMedia.push({ media_fbid: photoId });
            }
          } else if (imageSource === "upload" && selectedImages.length > 0) {
            // Nếu nguồn ảnh là upload và đã tải lên ảnh
            for (const imgUrl of selectedImages) {
              const imageToUpload = dataURLtoBlob(imgUrl);
              const photoId = await uploadImage(imageToUpload);
              attachedMedia.push({ media_fbid: photoId });
            }
          } else if (imageSource === "ai" && geminiGeneratedImage) {
            // Nếu nguồn ảnh là AI và đã tạo được ảnh từ Gemini
            const photoId = await uploadImage(geminiGeneratedImage);
            attachedMedia.push({ media_fbid: photoId });
          } else if (generatedPost.images && generatedPost.images.length > 0) {
            // Nếu có mảng ảnh từ API
            for (const imgUrl of generatedPost.images) {
              if (
                typeof imgUrl === "string" &&
                imgUrl.startsWith("data:image")
              ) {
                const imageToUpload = dataURLtoBlob(imgUrl);
                const photoId = await uploadImage(imageToUpload);
                attachedMedia.push({ media_fbid: photoId });
              } else {
                const photoId = await uploadImage(imgUrl);
                attachedMedia.push({ media_fbid: photoId });
              }
            }
          } else if (generatedPost.image) {
            // Nếu không thuộc các trường hợp trên nhưng có ảnh trong bài viết
            const photoId = await uploadImage(generatedPost.image);
            attachedMedia.push({ media_fbid: photoId });
          }
        }

        // Prepare post data
        const postData = {
          message: generatedPost.text,
          access_token: userAccessToken,
        };

        // Add attached_media only if there are images and it's not a text-only post
        if (!allowNoImage && attachedMedia.length > 0) {
          postData.attached_media = attachedMedia;
        }

        // Đăng bài lên tường cá nhân bằng axios (thay vì FB.api vì SDK hay treo)
        console.log("📤 Gọi Graph API để đăng bài lên tường cá nhân");
        const postResponse = await axios.post(
          `https://graph.facebook.com/v21.0/me/feed`,
          postData,
          { timeout: 30000 }
        );

        if (postResponse.data && postResponse.data.id) {
          console.log("✅ Đăng bài tường cá nhân thành công, postId:", postResponse.data.id);
          toast.success("Đăng bài thành công lên tường cá nhân!", {
            position: "top-right",
            autoClose: 3000,
          });
          incrementPostedCount();
          return postResponse.data;
        } else {
          throw new Error("Facebook không trả về post ID");
        }
      } catch (error) {
        console.error("Failed to publish to profile:", error);

        // Nếu là lỗi khi đăng bài với ảnh AI và còn cơ hội thử lại
        if (imageSource === "ai" && retryCount < maxRetries) {
          retryCount++;
          console.log(`Thử lại lần ${retryCount}/${maxRetries}...`);
          await new Promise((resolve) => setTimeout(resolve, 2000)); // Đợi 2 giây
          return await tryPublishToProfile(); // Thử lại
        }

        toast.error("Không thể đăng bài lên tường cá nhân!", {
          position: "top-right",
          autoClose: 3000,
        });
      } finally {
        // Luôn đặt lại trạng thái - tránh treo mãi ở "Đang đăng bài"
        setIsPublishing(false);
      }
    };

    // Gọi hàm thử xuất bản
    await tryPublishToProfile();
  };

  // Hàm lên lịch đăng bài - lưu vào Firebase theo dateKey
  const schedulePost = async ({ date, time }) => {
    if (selectedFanpages.length === 0) {
      toast.error("Vui lòng chọn ít nhất 1 fanpage để lên lịch!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (!generatedPost || !generatedPost.text) {
      toast.error("Vui lòng tạo bài viết trước khi lên lịch!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    const selectedAccountsPayload = selectedFanpages.map(toSelectedAccountPayload);
    const selectedHasZalo = selectedAccountsPayload.some(
      (account) => account.platform === "zalo"
    );

    setIsScheduling(true);

    try {
      const db = getDatabase();
      const userId = localStorage.getItem("userId");

      // Chuẩn bị dữ liệu ảnh - upload lên Cloudinary nếu là blob/base64
      let postImages = [];
      if (!allowNoImage) {
        let rawImages = [];
        if (imageSource === "upload" && selectedImages.length > 0) {
          rawImages = selectedImages;
        } else if (imageSource === "internet" && selectedSerperImages.length > 0) {
          rawImages = selectedSerperImages; // HTTP URLs - dùng trực tiếp
        } else if (imageSource === "ai" && geminiGeneratedImage) {
          rawImages = [geminiGeneratedImage];
        } else if (generatedPost.images && generatedPost.images.length > 0) {
          rawImages = generatedPost.images;
        } else if (generatedPost.image) {
          rawImages = [generatedPost.image];
        }

        // Upload non-HTTP images (base64/blob) lên Cloudinary
        for (const imgUrl of rawImages) {
          try {
            if (typeof imgUrl === "string" && imgUrl.startsWith("http")) {
              // Đã là URL thật → dùng trực tiếp
              postImages.push(imgUrl);
            } else if (typeof imgUrl === "string" && imgUrl.startsWith("data:")) {
              // Base64 data URL → upload lên Cloudinary
              const formData = new FormData();
              formData.append("file", imgUrl);
              formData.append("upload_preset", "AutoWork");
              formData.append("api_key", "238276161954221");

              const response = await axios.post(
                "https://api.cloudinary.com/v1_1/test-upload-1/image/upload",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
              );
              postImages.push(response.data.secure_url);
            } else {
              postImages.push(imgUrl);
            }
          } catch (uploadErr) {
            console.error("Lỗi upload ảnh lên Cloudinary:", uploadErr);
          }
        }
      }

      if (selectedHasZalo && postImages.length === 0) {
        toast.error(
          "Zalo OA bắt buộc có ảnh cover. Vui lòng chọn hoặc tạo ảnh trước khi lên lịch.",
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
        return;
      }

      // Chuẩn bị fanpage data (chỉ lưu thông tin cần thiết)
      const fanpageData = selectedFanpages
        .filter((fp) => (fp.platform || "facebook") === "facebook")
        .map(toLegacyFacebookFanpagePayload);

      // Tạo scheduled post data
      const scheduledPost = {
        content: generatedPost.text,
        images: postImages,
        selectedFanpages: fanpageData,
        selectedAccounts: selectedAccountsPayload,
        scheduleTime: time,
        status: "pending",
        createdAt: Date.now(),
        includeContactInfo: includeContactInfo,
        imageSource: imageSource,
        allowNoImage: allowNoImage,
      };

      // Lưu vào Firebase theo structure: /scheduledNormalPosts/{dateKey}/{userId}/{postId}
      const dateKey = date; // format: YYYY-MM-DD
      const scheduleRef = ref(db, `scheduledNormalPosts/${dateKey}/${userId}`);
      const newPostRef = push(scheduleRef);
      await update(ref(db), {
        [`scheduledNormalPosts/${dateKey}/${userId}/${newPostRef.key}`]:
          scheduledPost,
        [`userScheduledNormalPosts/${userId}/${dateKey}/${newPostRef.key}`]:
          scheduledPost,
      });

      setShowScheduleModal(false);

      toast.success(
        `Đã lên lịch đăng bài vào ${new Date(date).toLocaleDateString("vi-VN")} lúc ${time}!`,
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
    } catch (error) {
      console.error("Lỗi khi lên lịch đăng bài:", error);
      toast.error("Không thể lên lịch đăng bài. Vui lòng thử lại!", {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsScheduling(false);
    }
  };

  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  // Tạo hàm uploadImage riêng biệt để sử dụng chung
  const uploadImage = (image, fanpage) => {
    // Lấy access token từ fanpage hoặc từ localStorage nếu không có fanpage
    const accessToken = fanpage
      ? fanpage.access_token
      : localStorage.getItem("userAccessToken");
    const endpoint = fanpage
      ? `https://graph.facebook.com/${fanpage.id}/photos`
      : "https://graph.facebook.com/me/photos";

    return new Promise((resolve, reject) => {
      if (typeof image === "string" && image.startsWith("http")) {
        // Kiểm tra ảnh URL có truy cập được không
        const img = new Image();
        img.onload = () => {
          // Nếu ảnh tải được, tiến hành upload
          const formData = new FormData();
          formData.append("url", image);
          formData.append("published", "false");
          formData.append("access_token", accessToken);

          axios
            .post(endpoint, formData)
            .then((response) => {
              resolve(response.data.id);
            })
            .catch((error) => {
              let errorMessage = "Ảnh được chọn bị lỗi, vui lòng chọn ảnh khác";
              toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
              });
              reject(error);
            });
        };

        img.onerror = () => {
          toast.error(
            "Không thể truy cập URL hình ảnh. Vui lòng thử lại với ảnh khác.",
            {
              position: "top-right",
              autoClose: 3000,
            }
          );
          reject(new Error("Không thể truy cập URL hình ảnh"));
        };

        img.src = image;
      } else if (typeof image === "string" && image.startsWith("data:image")) {
        // Xử lý ảnh base64 từ Gemini - CẢI TIẾN cho thiết bị di động
        try {
          // Chuyển data URL thành Blob
          const imageBlob = dataURLtoBlob(image);

          // Kiểm tra kích thước Blob (nếu quá lớn có thể gây lỗi trên mobile)
          const blobSizeMB = imageBlob.size / (1024 * 1024);

          // Nếu ảnh quá lớn, thông báo cho người dùng nhưng vẫn thử tải lên
          if (blobSizeMB > 4) {
            console.warn(
              "Ảnh từ AI có kích thước lớn, có thể gặp vấn đề khi tải lên"
            );
          }

          // Tạo formData với ảnh dạng Blob
          const formData = new FormData();
          formData.append("source", imageBlob);
          formData.append("published", "false");
          formData.append("access_token", accessToken);

          // Tăng timeout cho request trên thiết bị di động
          axios
            .post(endpoint, formData, {
              timeout: 30000, // Tăng timeout lên 30 giây
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              resolve(response.data.id);
            })
            .catch((error) => {
              console.error("Lỗi khi upload ảnh Gemini:", error);

              // Thử lại một lần nữa khi gặp lỗi
              console.log("Thử lại upload ảnh...");
              setTimeout(() => {
                axios
                  .post(endpoint, formData, {
                    timeout: 60000, // Tăng timeout lên 60 giây cho lần thử lại
                  })
                  .then((response) => {
                    resolve(response.data.id);
                  })
                  .catch((retryError) => {
                    console.error(
                      "Lỗi khi thử lại upload ảnh Gemini:",
                      retryError
                    );
                    let errorMessage =
                      "Không thể đăng ảnh từ Gemini lên Facebook. Vui lòng thử lại sau.";
                    toast.error(errorMessage, {
                      position: "top-right",
                      autoClose: 3000,
                    });
                    reject(retryError);
                  });
              }, 2000); // Đợi 2 giây trước khi thử lại
            });
        } catch (error) {
          console.error("Lỗi khi xử lý ảnh base64 từ Gemini:", error);
          toast.error("Không thể xử lý ảnh từ Gemini", {
            position: "top-right",
            autoClose: 3000,
          });
          reject(error);
        }
      } else {
        // Xử lý cho trường hợp image là Blob hoặc các dạng khác
        try {
          // Tạo Blob từ image nếu nó chưa phải là Blob
          const blob = image instanceof Blob ? image : new Blob([image]);

          const formData = new FormData();
          formData.append("source", blob, "image.jpg");
          formData.append("published", "false");
          formData.append("access_token", accessToken);

          axios
            .post(endpoint, formData)
            .then((response) => {
              resolve(response.data.id);
            })
            .catch((error) => {
              let errorMessage = "Ảnh được chọn bị lỗi, vui lòng chọn ảnh khác";
              toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
              });
              reject(error);
            });
        } catch (error) {
          console.error("Lỗi khi xử lý ảnh:", error);
          toast.error("Không thể xử lý ảnh. Vui lòng thử lại.", {
            position: "top-right",
            autoClose: 3000,
          });
          reject(error);
        }
      }
    });
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleFanpageSelect = (fanpage) => {
    // Đóng dropdown sau khi chọn fanpage
    setIsDropdownOpen(false);

    // Chỉ chọn một fanpage duy nhất
    setSelectedFanpages([fanpage]);
    setSelectedFanpage(fanpage);
    console.log("Đã chọn account:", fanpage.name);

    // Lưu thông tin fanpage đã chọn vào localStorage để dễ truy cập
    try {
      if (fanpage.platform === "zalo") {
        return;
      }

      const db = getDatabase();
      const userId = localStorage.getItem("userId");

      // Lấy thông tin fanpage từ Firebase nếu có
      const fanpageInfoRef = ref(db, `users/${userId}/fanpages/${fanpage.id}`);
      get(fanpageInfoRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const fanpageInfo = snapshot.val();
            // Lưu vào localStorage để tiện sử dụng
            const storedFanpages = JSON.parse(
              localStorage.getItem("fanpages") || "{}"
            );
            storedFanpages[fanpage.id] = { ...fanpageInfo };
            localStorage.setItem("fanpages", JSON.stringify(storedFanpages));
          }
        })
        .catch((error) => {
          console.error("Lỗi khi đọc thông tin fanpage từ Firebase:", error);
        });
    } catch (error) {
      console.error("Lỗi khi lưu thông tin fanpage đã chọn:", error);
    }
  };

  // Thêm hàm xử lý thay đổi nguồn ảnh
  const handleImageSourceChange = (source) => {
    // Block AI source nếu chưa có gói Cao Cấp
    if (source === "ai" && userMembership < 3) {
      setShowUpgradeModal(true);
      return;
    }
    // Cập nhật nguồn ảnh
    setImageSource(source);
    const newSettings = {
      ...settings,
      imageSource: source,
    };
    saveUserSettings(newSettings);

    // Reset AI image khi đổi nguồn
    if (source !== "ai") {
      setGeminiGeneratedImage(null);
    }

    // Nếu đã có bài viết, cập nhật ảnh theo nguồn mới mà không gọi API
    if (generatedPost?.text) {
      if (source === "internet") {
        // Nếu chuyển sang internet và đã có ảnh Serper sẵn, hiển thị lại
        if (serperImages && serperImages.length > 0) {
          // Nếu đã có ảnh từ Serper, hiển thị ảnh đầu tiên
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            image: serperImages[0].imageUrl || "",
          }));
        } else {
          // Không gọi API, chỉ reset ảnh hiện tại
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            image: "",
          }));
        }
      } else if (source === "ai") {
        // Nếu chuyển sang AI và đã có ảnh Gemini sẵn, hiển thị lại
        if (geminiGeneratedImage) {
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            image: geminiGeneratedImage,
          }));
        } else {
          // Không gọi API, chỉ reset ảnh hiện tại
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            image: "",
          }));
        }
      } else if (source === "upload") {
        // Nếu chuyển sang upload, hiển thị ảnh đã tải lên nếu có
        if (selectedImages.length > 0) {
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            image: selectedImages[0] || "",
            images: selectedImages,
          }));
        } else {
          // Nếu không có ảnh đã tải lên, reset ảnh hiện tại
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            image: "",
            images: [],
          }));
        }
      }
    }
  };

  // Sửa hàm handleImageUpload để bỏ thông báo toast
  const handleImageUpload = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      // Giới hạn số lượng ảnh được thêm vào để tổng số không vượt quá 9
      const remainingSlots = 9 - selectedImages.length;
      if (remainingSlots <= 0) {
        toast.warning("Bạn chỉ có thể tải lên tối đa 9 ảnh");
        return;
      }

      const filesToAdd = Array.from(files).slice(0, remainingSlots);

      filesToAdd.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          setSelectedImages((prevImages) => [...prevImages, reader.result]);
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            images: [...(prevPost?.images || []), reader.result],
          }));
        };
        reader.readAsDataURL(file);
      });

      // Thông báo cho người dùng khi tải lên thành công
      // toast.success(
      //   `Đã tải lên ${filesToAdd.length} ảnh thành công. Nhấn "Tạo bài viết từ ảnh" để tiếp tục.`,
      //   {
      //     position: "top-right",
      //     autoClose: 3000,
      //   }
      // );
    }
  };

  // Hàm mới để tạo bài viết từ ảnh đã tải lên
  const generatePostFromUploadedImages = async () => {
    if (!checkPoints()) return;

    if (selectedImages.length === 0) {
      toast.error("Vui lòng tải lên ít nhất một ảnh để tạo bài viết", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    const userId = localStorage.getItem("userId");

    // Chuẩn bị tham số cho API
    const options = {
      postLength: postLength,
      postStyles: postStyles.join(", "),
      includeContactInfo: includeContactInfo,
      fanpageInfo: "",
      images: selectedImages,
    };

    setIsGeneratingPost(true);

    try {
      // Gọi API tạo bài viết từ ảnh
      const response = await axios.post(
        "/api/content/generate-post-from-image",
        {
          options,
          userId,
        }
      );

      if (response.data.success) {
        const { content, images } = response.data.data;

        setGeneratedPost({
          text: content,
          images: images || selectedImages,
        });

        // Cuộn xuống bài viết mới tạo
        setTimeout(() => {
          if (generatedPostRef.current) {
            generatedPostRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 100);
      } else {
        toast.error(
          response.data.message ||
            "Không thể tạo bài viết. Vui lòng thử lại sau.",
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
      }
    } catch (error) {
      console.error("Lỗi khi tạo bài viết từ ảnh:", error);
      toast.error("Đã xảy ra lỗi khi tạo bài viết. Vui lòng thử lại sau.", {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsGeneratingPost(false);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;

    if (files.length > 0) {
      // Giới hạn số lượng ảnh được thêm vào để tổng số không vượt quá 9
      const remainingSlots = 9 - selectedImages.length;
      if (remainingSlots <= 0) {
        toast.warning("Bạn chỉ có thể tải lên tối đa 9 ảnh", {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }

      const filesToAdd = Array.from(files).slice(0, remainingSlots);

      filesToAdd.forEach((file) => {
        if (!file.type.match("image.*")) {
          toast.error("Chỉ được phép tải lên file ảnh", {
            position: "top-right",
            autoClose: 3000,
          });
          return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
          setSelectedImages((prevImages) => [...prevImages, reader.result]);
          setGeneratedPost((prevPost) => ({
            ...prevPost,
            images: [...(prevPost?.images || []), reader.result],
            text: prevPost?.text || "",
          }));
        };
        reader.readAsDataURL(file);
      });

      // Không hiển thị toast ở đây
      // toast.success(`Đã tải lên ${filesToAdd.length} ảnh thành công.`, {
      //   position: "top-right",
      //   autoClose: 3000,
      // });
    }
  };

  const fileInputRef = React.useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  // Hàm xử lý khi ảnh lỗi - loại bỏ khỏi danh sách hợp lệ
  const handleImageError = (imageUrl) => {
    setValidSerperImages((prevValid) =>
      prevValid.filter((img) => img.imageUrl !== imageUrl)
    );
    setSelectedSerperImages((prev) => prev.filter((url) => url !== imageUrl));
  };

  // Cập nhật danh sách ảnh hợp lệ khi có ảnh mới từ serper
  useEffect(() => {
    setValidSerperImages(serperImages);
  }, [serperImages]);

  // Hàm mở preview cho ảnh upload
  const openUploadedImagePreview = (index) => {
    setCurrentImageIndex(index);
    const imageUrl =
      typeof selectedImages[index] === "string"
        ? selectedImages[index]
        : URL.createObjectURL(selectedImages[index]);
    setPreviewImage(imageUrl);
  };

  const openImagePreview = (imageUrl) => {
    // Kiểm tra xem ảnh thuộc loại nào
    if (selectedImages.includes(imageUrl)) {
      // Đây là ảnh upload
      const index = selectedImages.findIndex((img) => img === imageUrl);
      setCurrentImageIndex(index);
    } else {
      // Đây là ảnh serper - sử dụng danh sách ảnh hợp lệ
      const index = validSerperImages.findIndex(
        (img) => img.imageUrl === imageUrl
      );
      setCurrentImageIndex(index);
    }
    setPreviewImage(imageUrl);
  };

  const closeImagePreview = () => {
    setPreviewImage(null);
  };

  const handlePrevImage = (e) => {
    e.stopPropagation();
    if (previewImage && selectedImages.includes(previewImage)) {
      // Đây là ảnh upload
      if (selectedImages.length === 0) return;
      const newIndex =
        (currentImageIndex - 1 + selectedImages.length) % selectedImages.length;
      if (newIndex >= 0 && newIndex < selectedImages.length) {
        setCurrentImageIndex(newIndex);
        setPreviewImage(selectedImages[newIndex]);
      }
    } else {
      // Đây là ảnh serper - sử dụng danh sách ảnh hợp lệ
      const imagesList = validSerperImages;
      if (imagesList.length === 0) return;
      const newIndex =
        (currentImageIndex - 1 + imagesList.length) % imagesList.length;
      if (newIndex >= 0 && newIndex < imagesList.length) {
        setCurrentImageIndex(newIndex);
        setPreviewImage(imagesList[newIndex].imageUrl);
      }
    }
  };

  const handleNextImage = async (e) => {
    e.stopPropagation();
    if (previewImage && selectedImages.includes(previewImage)) {
      // Đây là ảnh upload
      if (selectedImages.length === 0) return;
      const newIndex = (currentImageIndex + 1) % selectedImages.length;
      if (newIndex >= 0 && newIndex < selectedImages.length) {
        setCurrentImageIndex(newIndex);
        setPreviewImage(selectedImages[newIndex]);
      }
    } else {
      // Đây là ảnh serper - sử dụng danh sách ảnh hợp lệ
      const imagesList = validSerperImages;
      if (imagesList.length === 0) return;
      const newIndex = (currentImageIndex + 1) % imagesList.length;
      if (newIndex >= 0 && newIndex < imagesList.length) {
        setCurrentImageIndex(newIndex);
        setPreviewImage(imagesList[newIndex].imageUrl);
      }
    }
  };

  useEffect(() => {
    const loadUserSettings = async () => {
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) return;

        const db = getDatabase();
        const settingsRef = ref(
          db,
          `users/${userId}/settings/normalPostGenerator`
        );
        const snapshot = await get(settingsRef);

        if (snapshot.exists()) {
          const settings = snapshot.val();
          setPostLength(settings.postLength || DEFAULT_POST_LENGTH);
          setPostStyles(settings.postStyles || DEFAULT_POST_STYLES);
          setIncludeContactInfo(settings.includeContactInfo || false);
          setUseGeminiForImage(settings.useGeminiForImage || false);
          setImageSource(settings.imageSource || "internet");
          setImageStyle(settings.imageStyle || DEFAULT_IMAGE_STYLE);
          setAspectRatio(settings.aspectRatio || DEFAULT_ASPECT_RATIO);
          setCustomImagePrompt(settings.customImagePrompt || "");
          setSelectedLanguage(settings.selectedLanguage || "vi");
        }

        // Load từ localStorage nếu không có trong Firebase
        const savedLanguage = localStorage.getItem("selectedLanguage");
        if (savedLanguage && !snapshot.exists()) {
          setSelectedLanguage(savedLanguage);
        }
      } catch (error) {
        console.error("Error loading settings:", error);
      }
    };

    loadUserSettings();
  }, []);

  const saveUserSettings = (settings) => {
    const currentSettings = JSON.parse(
      localStorage.getItem("postGeneratorSettings") || "{}"
    );
    const newSettings = { ...currentSettings, ...settings };
    localStorage.setItem("postGeneratorSettings", JSON.stringify(newSettings));
  };

  // Hàm xử lý thay đổi ngôn ngữ
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    // Lưu vào localStorage
    localStorage.setItem("selectedLanguage", language);
    // Lưu vào settings để sync với Firebase
    const newSettings = {
      ...settings,
      selectedLanguage: language,
    };
    saveUserSettings(newSettings);
  };

  const handleIncludeContactInfoChange = (e) => {
    setIncludeContactInfo(!includeContactInfo);
    saveUserSettings({ includeContactInfo: !includeContactInfo });
  };

  // Premium Grounding: opt-in toggle. Default OFF. Chỉ dùng được cho gói Cao Cấp/Doanh Nghiệp (BE sẽ check).
  // GroundingToggle component passes the new value (bool), not an event.
  const handleUseGoogleSearchChange = (newValue) => {
    setUseGoogleSearch(newValue);
    saveUserSettings({ useGoogleSearch: newValue });
  };

  // Xử lý xóa ảnh đã tải lên
  const handleRemoveImage = (index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages.splice(index, 1);
      return newImages;
    });

    setGeneratedPost((prevPost) => {
      const newImages = [...(prevPost?.images || [])];
      newImages.splice(index, 1);
      return {
        ...prevPost,
        images: newImages,
      };
    });
  };

  // Xử lý thay đổi các thiết lập bài viết
  const handlePostLengthChange = (e) => {
    setPostLength(e.target.value);
    saveUserSettings({ postLength: e.target.value });
  };

  const handleStyleTagClick = (tag) => {
    // Implement the logic for handling style tag click
    console.log(`Style tag clicked: ${tag}`);
  };

  // Thêm hàm xử lý việc bật/tắt chế độ chỉnh sửa
  const toggleEditMode = () => {
    if (isEditMode) {
      // Khi hoàn thành chỉnh sửa, cập nhật nội dung bài viết
      // Chỉ đánh dấu là đã chỉnh sửa nếu nội dung thực sự thay đổi
      if (editedPostText !== generatedPost.text) {
        setGeneratedPost((prevPost) => ({
          ...prevPost,
          text: editedPostText,
        }));
        setHasEdited(true);
        toast.success("Đã lưu thay đổi nội dung bài viết!", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        toast.info("Không có thay đổi để lưu.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } else {
      // Khi bắt đầu chỉnh sửa, cập nhật trường editedPostText
      setEditedPostText(generatedPost.text);
    }
    setIsEditMode(!isEditMode);
  };

  // Thêm hàm hủy chỉnh sửa
  const cancelEdit = () => {
    setEditedPostText(generatedPost.text);
    setIsEditMode(false);
    // Không cần cập nhật hasEdited vì chúng ta đang hủy thay đổi
  };

  // Thêm hàm copyToClipboard
  const copyToClipboard = () => {
    if (!generatedPost) return;

    navigator.clipboard
      .writeText(generatedPost.text)
      .then(() => {
        toast.success("Đã sao chép nội dung bài viết vào clipboard!", {
          position: "top-right",
          autoClose: 3000,
        });
      })
      .catch((error) => {
        console.error("Lỗi khi sao chép vào clipboard:", error);
        toast.error("Không thể sao chép nội dung. Vui lòng thử lại sau.", {
          position: "top-right",
          autoClose: 3000,
        });
      });
  };

  const copyContent = (text, label) => {
    if (!text) return;
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success(`Đã sao chép ${label} vào clipboard!`, {
          position: "top-right",
          autoClose: 3000,
        });
      })
      .catch((error) => {
        console.error("Lỗi khi sao chép:", error);
        toast.error("Không thể sao chép. Vui lòng thử lại sau.", {
          position: "top-right",
          autoClose: 3000,
        });
      });
  };

  // Thêm hàm validation cho URL
  const validateUrls = (urlString) => {
    if (!urlString.trim()) {
      return { isValid: true, urls: [], errors: [] };
    }

    // Chỉ lấy URL đầu tiên từ input
    const firstUrl = urlString
      .trim()
      .split(/[,\n\s]+/)[0]
      .trim();

    const validUrls = [];
    const errors = [];

    if (firstUrl) {
      try {
        // Thêm https:// nếu URL không có protocol
        let normalizedUrl = firstUrl;
        if (!firstUrl.match(/^https?:\/\//)) {
          normalizedUrl = `https://${firstUrl}`;
        }

        const urlObj = new URL(normalizedUrl);

        // Kiểm tra xem có phải là URL hợp lệ không
        if (urlObj.protocol === "http:" || urlObj.protocol === "https:") {
          validUrls.push(normalizedUrl);
        } else {
          errors.push(`Protocol không được hỗ trợ (${urlObj.protocol})`);
        }
      } catch (error) {
        errors.push(`"${firstUrl}" không phải là URL hợp lệ`);
      }
    }

    // Kiểm tra nếu người dùng nhập nhiều URL
    const allUrls = urlString
      .trim()
      .split(/[,\n\s]+/)
      .filter((url) => url.trim().length > 0);
    if (allUrls.length > 1) {
      errors.push("Chỉ hỗ trợ 1 URL duy nhất");
    }

    return {
      isValid: errors.length === 0 && validUrls.length <= 1,
      urls: validUrls,
      errors: errors,
    };
  };

  // Hàm xử lý thay đổi URL input
  const handleUrlsChange = (value) => {
    setInputUrls(value);

    // Reset errors khi người dùng đang gõ
    if (urlValidationErrors.length > 0) {
      setUrlValidationErrors([]);
    }
  };

  // Hàm validate URLs khi người dùng blur
  const handleUrlsBlur = () => {
    const validation = validateUrls(inputUrls);
    setUrlValidationErrors(validation.errors);
  };

  // Report handling functions
  const openReportModal = () => {
    setShowReportModal(true);
    setReportType("");
    setReportDescription("");
  };

  const closeReportModal = () => {
    setShowReportModal(false);
    setReportType("");
    setReportDescription("");
  };

  const handleReportSubmit = async () => {
    if (!reportType) {
      toast.error("Vui lòng chọn loại lỗi!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setIsSubmittingReport(true);
    const userId = localStorage.getItem("userId");

    try {
      const reportData = {
        userId: userId || "Người dùng ẩn danh",
        errorType: reportType,
        description: reportDescription || "Không có mô tả chi tiết",
        language: getLanguageName(selectedLanguage),
        postLength: postLength,
        postStyles: postStyles.join(", "),
        referenceUrl: inputUrls || null,
        postContent: generatedPost?.text || "Không có nội dung",
        userAgent: navigator.userAgent,
        imageSource: imageSource,
        fanpageName: selectedFanpage?.name || "Không xác định",
        postType: "normalPostGenerator", // Phân biệt với WebsitePostGenerator
      };

      const success = await sendPostReportNotification(reportData);

      if (success) {
        toast.success(
          "🙏 Cảm ơn bạn đã báo cáo! Chúng tôi sẽ cải thiện hệ thống.",
          {
            position: "top-right",
            autoClose: 4000,
          }
        );
        closeReportModal();
      } else {
        toast.error("Không thể gửi báo cáo. Vui lòng thử lại sau.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Lỗi khi gửi báo cáo:", error);
      toast.error("Đã xảy ra lỗi khi gửi báo cáo. Vui lòng thử lại sau.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setIsSubmittingReport(false);
    }
  };

  // Pre-defined report types for Facebook posts
  const reportTypes = [
    { value: "content_quality", label: "🤖 Nội dung AI không tự nhiên, kỳ lạ" },
    {
      value: "content_incomplete",
      label: "📝 Nội dung thiếu sót, không đầy đủ",
    },
    {
      value: "content_irrelevant",
      label: "🎯 Nội dung không liên quan đến yêu cầu",
    },
    { value: "image_error", label: "🖼️ Ảnh lỗi hoặc không phù hợp" },
    {
      value: "formatting_error",
      label: "📋 Định dạng bài đăng Facebook bị lỗi",
    },
    { value: "language_error", label: "🌐 Ngôn ngữ sai hoặc lỗi ngữ pháp" },
    { value: "duplicate_content", label: "📄 Nội dung bị lặp lại" },
    { value: "url_processing_error", label: "🔗 Lỗi xử lý URL tham khảo" },
    { value: "posting_failed", label: "📤 Không đăng được lên Facebook" },
    { value: "other", label: "❓ Lỗi khác" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <div className="max-w-full mx-auto px-2 sm:px-3 pt-6 pb-8">
        <div className="mb-6">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 text-center">
            TẠO BÀI VIẾT TỪ CHỦ ĐỀ VỚI AI
          </h1>
        </div>

        <PointWarning
          title="Vui lòng nạp thêm điểm để tiếp tục dùng chức năng này nhé ;)"
          userPoint={userPoints}
        />

        <div className="flex flex-col md:flex-row gap-6">
          {/* Phần bên trái - Form nhập yêu cầu */}
          <div className="w-full md:w-1/2">
            <div className="bg-white rounded-md shadow-md p-5 mb-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold text-gray-800">
                  Nội dung
                </h2>
                <a
                  href="https://youtu.be/tRLvNv64bK8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 text-sm font-medium rounded-md shadow-sm transition duration-300 hover:text-red-600"
                  title="Xem video hướng dẫn cách sử dụng"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-red-600"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                  </svg>
                  <span>Hướng dẫn</span>
                </a>
              </div>

              {/* Platform selection tabs */}
              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">
                  Nền tảng nội dung
                </label>
                <div className="flex p-1 space-x-1 bg-gray-100 rounded-lg shadow-inner">
                  <button
                    type="button"
                    className={`flex-1 py-2.5 text-sm font-medium rounded-md transition-colors duration-200 flex items-center justify-center ${
                      contentPlatform === "facebook"
                        ? "bg-blue-600 text-white"
                        : "bg-white text-gray-700 hover:bg-gray-50"
                    }`}
                    onClick={() => {
                      setContentPlatform("facebook");
                      setZaloArticle(null);
                      setSelectedFanpage(null);
                      setSelectedFanpages([]);
                    }}
                  >
                    <FiFacebook className="mr-2" />
                    Facebook
                  </button>
                  <button
                    type="button"
                    className={`flex-1 py-2.5 text-sm font-medium rounded-md transition-colors duration-200 flex items-center justify-center ${
                      contentPlatform === "zalo"
                        ? "bg-blue-600 text-white"
                        : "bg-white text-gray-700 hover:bg-gray-50"
                    }`}
                    onClick={() => {
                      setContentPlatform("zalo");
                      setSelectedFanpage(null);
                      setSelectedFanpages([]);
                    }}
                  >
                    <span className="mr-2 font-bold">Z</span>
                    Zalo OA
                  </button>
                </div>
                {contentPlatform === "zalo" && (
                  <p className="mt-2 text-sm text-blue-600">
                    Bài viết sẽ được tạo theo định dạng Zalo OA Article (tiêu đề, mô tả, nội dung riêng biệt)
                  </p>
                )}
              </div>

              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">
                  Nhập yêu cầu bài viết
                  <span className="text-sm text-gray-500 font-normal ml-2">
                    (Tùy chọn - có thể để trống nếu có URL)
                  </span>
                </label>
                <div className="relative">
                  <textarea
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-medium text-gray-700"
                    rows="5"
                    value={requirements}
                    onChange={(e) => setRequirements(e.target.value)}
                    placeholder="Nhập yêu cầu bài viết hoặc để trống nếu chỉ dùng URL..."
                  ></textarea>
                  {requirements && (
                    <button
                      onClick={() => setRequirements("")}
                      className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                      title="Xóa nội dung"
                    >
                      <FiXCircle size={20} />
                    </button>
                  )}
                  <div className="flex justify-between items-center mt-1 text-xs">
                    <span className="text-gray-400">
                      Gợi ý: Cung cấp thông tin chi tiết để AI viết hay hơn.
                    </span>
                    <span className={`font-semibold ${
                      requirements.length > 8000
                        ? "text-red-500"
                        : requirements.length > 6000
                        ? "text-orange-500"
                        : "text-gray-400"
                    }`}>
                      {requirements.length} / 8000 ký tự
                    </span>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">
                  Nhập URL tham khảo (tùy chọn)
                </label>
                <div className="relative">
                  <input
                    type="text"
                    className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-medium text-gray-700 ${
                      urlValidationErrors.length > 0
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                    value={inputUrls}
                    onChange={(e) => handleUrlsChange(e.target.value)}
                    onBlur={handleUrlsBlur}
                    placeholder="Nhập URL tham khảo... VD: https://example.com"
                  />
                  {inputUrls && (
                    <button
                      onClick={() => {
                        setInputUrls("");
                        setUrlValidationErrors([]);
                      }}
                      className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                      title="Xóa URLs"
                    >
                      <FiXCircle size={20} />
                    </button>
                  )}
                </div>

                {/* Hiển thị lỗi validation */}
                {urlValidationErrors.length > 0 && (
                  <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
                    <div className="flex items-start">
                      <svg
                        className="h-5 w-5 text-red-400 mt-0.5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div>
                        <h4 className="text-sm font-medium text-red-800 mb-1">
                          Lỗi URL:
                        </h4>
                        <ul className="text-sm text-red-700 space-y-1">
                          {urlValidationErrors.map((error, index) => (
                            <li key={index}>• {error}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {/* Hiển thị thông tin hữu ích */}
                {inputUrls && urlValidationErrors.length === 0 && (
                  <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-md">
                    <div className="flex items-start">
                      <svg
                        className="h-5 w-5 text-blue-400 mt-0.5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div className="text-sm text-blue-700">
                        <p className="mb-1">
                          <strong>URL hợp lệ được phát hiện.</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">
                  Độ dài bài viết
                </label>
                <div className="flex w-full rounded-md shadow-sm">
                  {POST_LENGTHS.map(({ value, label }, index) => (
                    <button
                      key={value}
                      type="button"
                      className={`flex-1 py-2 px-2 text-center text-sm font-medium
                        ${index === 0 ? "rounded-l-md" : ""}
                        ${
                          index === POST_LENGTHS.length - 1
                            ? "rounded-r-md"
                            : ""
                        }
                        ${
                          postLength === value
                            ? "bg-blue-600 text-white z-10"
                            : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300"
                        }`}
                      onClick={() => setPostLength(value)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">
                  Phong cách bài viết
                </label>
                <div className="flex flex-wrap gap-2">
                  {POST_STYLES.map(({ value, label }) => (
                    <button
                      key={value}
                      type="button"
                      className={`py-2 px-4 rounded-full text-sm font-medium
                        ${
                          postStyles.includes(value)
                            ? "bg-blue-600 text-white"
                            : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300"
                        }`}
                      onClick={() => handlePostStyleChange(value)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Thêm PostLanguageSelector vào đây */}
              <PostLanguageSelector
                selectedLanguage={selectedLanguage}
                onLanguageChange={handleLanguageChange}
                disabled={isGeneratingPost || isSuggestingTopics}
              />

              {/* Thêm ImageSourceSelector vào đây */}
              <ImageSourceSelector
                selectedSource={imageSource}
                setSelectedSource={handleImageSourceChange}
                disabled={allowNoImage}
                allowNoImage={allowNoImage}
                setAllowNoImage={setAllowNoImage}
                isPremiumLocked={userMembership < 3}
              />

              {/* AI Image Settings - hiển thị khi chọn nguồn ảnh AI */}
              {imageSource === "ai" && !allowNoImage && (
                <div className="mb-6 bg-gradient-to-r from-purple-50 to-blue-50 border border-purple-200 rounded-lg p-4">
                  <h3 className="text-sm font-semibold text-purple-700 mb-3 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1.5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                    </svg>
                    Cài đặt ảnh AI
                  </h3>

                  {/* Phong cách ảnh - Dropdown giống AutoPostGenerator */}
                  <div className="mb-3">
                    <label className="block text-gray-700 text-sm font-medium mb-1">
                      Phong cách ảnh
                    </label>
                    <div className="relative" ref={styleDropdownRef}>
                      <button
                        type="button"
                        onClick={() => setIsStyleDropdownOpen(!isStyleDropdownOpen)}
                        className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-left text-sm flex items-center justify-between hover:border-blue-400 transition-colors"
                      >
                        <span>
                          {IMAGE_STYLE_OPTIONS.find((s) => s.value === imageStyle)?.label || "Chọn phong cách"}
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-4 w-4 text-gray-400 transition-transform ${isStyleDropdownOpen ? "rotate-180" : ""}`}
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                      {isStyleDropdownOpen && (
                        <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                          {IMAGE_STYLE_OPTIONS.map((style) => (
                            <button
                              key={style.value}
                              type="button"
                              onClick={() => {
                                setImageStyle(style.value);
                                setIsStyleDropdownOpen(false);
                                const newSettings = {
                                  ...settings,
                                  imageStyle: style.value,
                                };
                                saveUserSettings(newSettings);
                              }}
                              className={`w-full text-left px-3 py-2 text-sm hover:bg-blue-50 transition-colors ${
                                imageStyle === style.value
                                  ? "bg-blue-50 text-blue-700 font-medium"
                                  : "text-gray-700"
                              }`}
                            >
                              {style.label}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Tỷ lệ ảnh */}
                  <div className="mb-3">
                    <label className="block text-gray-700 text-sm font-medium mb-1">
                      Tỷ lệ ảnh
                    </label>
                    <div className="flex gap-2">
                      {ASPECT_RATIO_OPTIONS.map((ratio) => (
                        <button
                          key={ratio.value}
                          type="button"
                          onClick={() => {
                            setAspectRatio(ratio.value);
                            const newSettings = {
                              ...settings,
                              aspectRatio: ratio.value,
                            };
                            saveUserSettings(newSettings);
                          }}
                          className={`flex-1 py-1.5 px-2 rounded-md text-xs font-medium border transition-colors ${
                            aspectRatio === ratio.value
                              ? "bg-blue-600 text-white border-blue-600"
                              : "bg-white text-gray-700 border-gray-300 hover:border-blue-400"
                          }`}
                        >
                          {ratio.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Yêu cầu thêm cho ảnh */}
                  <div>
                    <label className="block text-gray-700 text-sm font-medium mb-1">
                      Yêu cầu thêm cho ảnh
                      <span className="text-gray-400 font-normal ml-1">(tùy chọn)</span>
                    </label>
                    <textarea
                      value={customImagePrompt}
                      onChange={(e) => {
                        setCustomImagePrompt(e.target.value);
                        const newSettings = {
                          ...settings,
                          customImagePrompt: e.target.value,
                        };
                        saveUserSettings(newSettings);
                      }}
                      maxLength={500}
                      placeholder="VD: Ảnh có tone màu ấm, có người đang cười..."
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none"
                      rows="2"
                    />
                  </div>
                </div>
              )}

              <div className="mb-6">
                <div className="flex items-center justify-between bg-gray-50 rounded-md p-3">
                  <label className="text-gray-700 font-medium">
                    Thêm thông tin liên hệ vào cuối bài viết
                  </label>
                  <div className="relative inline-block w-12 align-middle select-none">
                    <input
                      type="checkbox"
                      name="contactInfo"
                      id="contactInfo"
                      checked={includeContactInfo}
                      onChange={handleIncludeContactInfoChange}
                      className="hidden"
                    />
                    <label
                      htmlFor="contactInfo"
                      className={`block overflow-hidden h-6 rounded-full cursor-pointer transition-colors duration-200 ease-in-out
                        ${includeContactInfo ? "bg-blue-600" : "bg-gray-300"}`}
                    >
                      <span
                        className={`block h-6 w-6 rounded-full shadow transform transition-transform duration-200 ease-in-out
                          ${
                            includeContactInfo
                              ? "translate-x-6 bg-white"
                              : "translate-x-0 bg-white"
                          }`}
                      />
                    </label>
                  </div>
                </div>
                {includeContactInfo && (
                  <div className="mt-3 p-3 bg-blue-50 text-blue-700 rounded-md">
                    <p className="text-sm">
                      Hệ thống sẽ tự động thêm thông tin liên hệ của {contentPlatform === "zalo" ? "Zalo OA" : "Fanpage"} vào
                      cuối bài viết khi đăng lên {contentPlatform === "zalo" ? "Zalo" : "Facebook"}.
                    </p>
                  </div>
                )}
              </div>

              {/* === Premium Grounding: Google Search opt-in (gói Cao Cấp/Doanh Nghiệp) === */}
              <div className="mb-6">
                <GroundingToggle
                  useGoogleSearch={useGoogleSearch}
                  onChange={handleUseGoogleSearchChange}
                  isPlanEligible={userMembership >= 3}
                  contextLabel="bài viết thường"
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">
                  Chọn tài khoản để đăng bài
                </label>
                {filteredFanpages.length === 0 ? (
                  <button
                    onClick={() => {
                      navigate("/profile");
                      setTimeout(() => {
                        const element = document.getElementById(
                          "facebook-fanpage-management"
                        );
                        if (element) {
                          element.scrollIntoView({ behavior: "smooth" });
                        }
                      }, 500);
                    }}
                    className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 text-sm sm:text-base"
                  >
                    {contentPlatform === "zalo"
                      ? "Kết nối tài khoản Zalo OA để đăng bài"
                      : "Thiết lập tài khoản Facebook để đăng bài"}
                  </button>
                ) : (
                  <div ref={dropdownRef} className="relative">
                    <button
                      onClick={toggleDropdown}
                      className="w-full px-4 py-2.5 bg-white border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center font-medium"
                    >
                      <span>
                        {selectedFanpage
                          ? selectedFanpage.name
                          : contentPlatform === "zalo"
                          ? "Chọn Zalo OA"
                          : "Chọn Fanpage"}
                      </span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-gray-500"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                    {isDropdownOpen && (
                      <div className="absolute z-50 bg-white border border-gray-300 rounded-md shadow-xl overflow-hidden w-full mt-1">
                        <div className="max-h-60 overflow-y-auto">
                          {filteredFanpages.map((fanpage) => (
                            <div
                              key={getSocialAccountKey(fanpage)}
                              onClick={() => handleFanpageSelect(fanpage)}
                              className={`px-4 py-3 hover:bg-blue-50 cursor-pointer flex items-center justify-between ${
                                selectedFanpage &&
                                getSocialAccountKey(selectedFanpage) ===
                                  getSocialAccountKey(fanpage)
                                  ? "bg-blue-50"
                                  : ""
                              } ${
                                fanpage !== fanpages[fanpages.length - 1]
                                  ? "border-b border-gray-100"
                                  : ""
                              }`}
                            >
                              <span className="font-medium text-gray-800">
                                {fanpage.name}
                              </span>
                              <span className="text-xs text-gray-500 uppercase">
                                {fanpage.platform === "zalo" ? "Zalo OA" : "Facebook"}
                              </span>
                            </div>
                          ))}
                        </div>
                        <div className="px-4 py-2 border-t border-gray-100 bg-gray-50 flex justify-between">
                          <button
                            onClick={() => setIsDropdownOpen(false)}
                            className="text-sm text-gray-600 hover:text-gray-800 font-medium"
                          >
                            Đóng
                          </button>
                          {selectedFanpage && (
                            <button
                              onClick={() => {
                                setSelectedFanpage("");
                                // Cập nhật cả selectedFanpages khi bỏ chọn
                                setSelectedFanpages([]);
                              }}
                              className="text-sm text-red-500 hover:text-red-700 font-medium"
                            >
                              Bỏ chọn
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Nút tạo bài viết */}
              <div className="flex flex-col space-y-4">
                <div className="flex flex-row space-x-3">
                  <>
                    <button
                      className="flex-1 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md flex items-center justify-center transition-colors disabled:opacity-60 disabled:pointer-events-none"
                      onClick={generatePost}
                      disabled={
                        isLoading || isGeneratingPost || userPoints <= 0
                      }
                    >
                      {isGeneratingPost ? (
                        <div className="flex items-center">
                          <ClipLoader
                            size={20}
                            color="#ffffff"
                            className="mr-2"
                          />
                          <span>Đang tạo bài viết...</span>
                        </div>
                      ) : (
                        <>
                          <FiRefreshCw className="mr-2" />
                          Tạo bài viết
                          <span className="ml-2 border border-white border-opacity-50 text-white text-xs px-2 py-0.5 rounded-full opacity-90">
                            {imageSource === "ai" && !allowNoImage
                              ? "−58"
                              : imageSource === "internet" && !allowNoImage
                              ? useGoogleSearch
                                ? "−20"
                                : "−10"
                              : useGoogleSearch
                                ? "−18"
                                : "−8"} điểm
                          </span>
                        </>
                      )}
                    </button>
                    <button
                      onClick={suggestTopics}
                      disabled={
                        isGeneratingPost ||
                        isSuggestingTopics ||
                        userPoints <= 0
                      }
                      className="flex-1 items-center justify-center bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50 transition-colors font-medium flex"
                    >
                      <FiRefreshCw
                        className={`mr-2 ${
                          isSuggestingTopics ? "animate-spin" : ""
                        }`}
                      />
                      {isSuggestingTopics
                        ? "Đang gợi ý chủ đề..."
                        : "Gợi ý chủ đề"}
                    </button>
                  </>
                </div>
                {userPoints <= 0 && (
                  <p className="text-red-500 text-sm mt-2 text-center">
                    Bạn không đủ điểm để tạo bài viết. Vui lòng nạp thêm điểm!
                  </p>
                )}
              </div>
            </div>

            {suggestedTopics.length > 0 && (
              <div className="relative bg-white rounded-md shadow-md p-5 mb-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  Chọn chủ đề
                </h2>
                <ul className="space-y-2 mb-4">
                  {suggestedTopics.map((topic, index) => (
                    <li
                      key={index}
                      onClick={() => handleTopicSelect(topic)}
                      className={`cursor-pointer p-2 rounded-md hover:bg-gray-50 ${
                        selectedTopic === topic
                          ? "bg-blue-50 border-l-4 border-blue-500 font-medium"
                          : ""
                      }`}
                    >
                      {topic}
                    </li>
                  ))}
                </ul>
                <FiXCircle
                  onClick={clearSuggestedTopics}
                  className="absolute top-4 right-4 text-red-600 cursor-pointer"
                  size={24}
                />
                <button
                  onClick={generatePost}
                  disabled={isGeneratingPost || isSuggestingTopics}
                  className="flex items-center justify-center w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 mb-2 font-medium"
                >
                  <FiRefreshCw
                    className={`mr-2 ${isGeneratingPost ? "animate-spin" : ""}`}
                  />
                  {isGeneratingPost
                    ? "Đang tạo bài viết..."
                    : "Tạo bài viết từ chủ đề được chọn"}
                </button>
                <button
                  onClick={suggestTopics}
                  disabled={isGeneratingPost || isSuggestingTopics}
                  className="flex items-center justify-center w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50 font-medium"
                >
                  <FiRefreshCw
                    className={`mr-2 ${
                      isSuggestingTopics ? "animate-spin" : ""
                    }`}
                  />
                  {isSuggestingTopics
                    ? "Đang gợi ý chủ đề..."
                    : "Gợi ý chủ đề khác"}
                </button>
              </div>
            )}
          </div>

          {/* Phần bên phải - Kết quả */}
          <div className="w-full md:w-1/2">
            {generatedPost ? (
              <div
                ref={generatedPostRef}
                className="bg-white rounded-md shadow-md p-5 overflow-hidden mb-20 md:mb-0"
              >
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Bài viết đã tạo
                    {/* Hiển thị indicator khi có URL được sử dụng */}
                    {validateUrls(inputUrls).urls.length > 0 && (
                      <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        Từ URL tham khảo
                      </span>
                    )}
                  </h2>
                  {!isEditMode && (
                    <div className="flex gap-2">
                      <button
                        onClick={openReportModal}
                        className="px-3 py-2.5 sm:py-1.5 bg-orange-50 hover:bg-orange-100 text-orange-700 rounded-md font-medium text-sm flex items-center"
                        title="Báo cáo lỗi bài viết (Ctrl+R)"
                      >
                        <FiFlag className="mr-1" size={16} />
                        Báo cáo
                      </button>
                      <button
                        onClick={toggleEditMode}
                        className="px-3 py-2.5 sm:py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-md font-medium text-sm flex items-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-1"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                          />
                        </svg>
                        Sửa
                      </button>
                      <button
                        onClick={copyToClipboard}
                        className="px-3 py-2.5 sm:py-1.5 bg-purple-50 hover:bg-purple-100 text-purple-700 rounded-md font-medium text-sm flex items-center"
                      >
                        <FiCopy className="h-4 w-4 mr-1" />
                        Copy
                      </button>
                      <button
                        onClick={regeneratePost}
                        disabled={isRegeneratingPost}
                        className="px-3 py-2.5 sm:py-1.5 bg-green-50 hover:bg-green-100 text-green-700 rounded-md font-medium text-sm flex items-center"
                      >
                        <FiRefreshCw
                          className={`h-4 w-4 mr-1 ${
                            isRegeneratingPost ? "animate-spin" : ""
                          }`}
                        />
                        {isRegeneratingPost ? "Đang viết lại..." : "Viết lại"}
                      </button>
                    </div>
                  )}
                </div>

                <div className="mb-6">
                  {isEditMode ? (
                    <div className="mb-3">
                      <div className="relative">
                        <textarea
                          className="w-full p-4 border border-gray-300 rounded-md focus:border-blue-500 focus:ring-1 focus:ring-blue-500 resize-none overflow-hidden"
                          value={editedPostText}
                          onChange={(e) => {
                            setEditedPostText(e.target.value);
                            // Tự động điều chỉnh chiều cao
                            e.target.style.height = "auto";
                            e.target.style.height =
                              Math.max(100, e.target.scrollHeight) + "px";
                          }}
                          onKeyDown={(e) => {
                            // Thêm shortcut Ctrl+Enter để lưu chỉnh sửa
                            if (e.ctrlKey && e.key === "Enter") {
                              toggleEditMode();
                            }
                            // Shortcut Esc để hủy
                            if (e.key === "Escape") {
                              cancelEdit();
                            }
                          }}
                          ref={(el) => {
                            if (el) {
                              el.style.height = "auto";
                              el.style.height =
                                Math.max(100, el.scrollHeight) + "px";
                            }
                          }}
                          placeholder="Nhập nội dung bài viết..."
                        ></textarea>
                        <div className="absolute bottom-2 right-3 text-xs text-gray-500 bg-white px-1.5 py-0.5 rounded-full border border-gray-200">
                          {editedPostText.length} ký tự
                        </div>
                      </div>
                      <div className="flex items-center justify-between mt-3">
                        <div className="text-xs text-gray-500 hidden sm:block">
                          <kbd className="px-1 py-0.5 bg-gray-100 border border-gray-300 rounded">
                            Ctrl
                          </kbd>{" "}
                          +{" "}
                          <kbd className="px-1 py-0.5 bg-gray-100 border border-gray-300 rounded">
                            Enter
                          </kbd>{" "}
                          để lưu •{" "}
                          <kbd className="px-1 py-0.5 bg-gray-100 border border-gray-300 rounded">
                            Esc
                          </kbd>{" "}
                          để hủy
                        </div>
                        <div className="flex gap-2 ml-auto">
                          <button
                            onClick={cancelEdit}
                            className="px-4 py-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md font-medium text-sm"
                          >
                            Hủy
                          </button>
                          <button
                            onClick={toggleEditMode}
                            className="px-4 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded-md font-medium text-sm"
                          >
                            Lưu thay đổi
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                    {/* Chỉ hiển thị plain text preview khi KHÔNG phải Zalo hoặc chưa có zaloArticle */}
                    {!(contentPlatform === "zalo" && zaloArticle) && (
                    <div className="relative mb-6">
                      <div
                        className="p-4 bg-gray-50 rounded-md text-base whitespace-pre-line break-words border border-gray-200"
                        style={{
                          minHeight: "100px",
                          height: "auto",
                        }}
                      >
                        {generatedPost.text}
                      </div>
                      <button
                        onClick={() => copyContent(generatedPost.text, "nội dung")}
                        className="absolute top-2 right-2 p-2 text-gray-400 hover:text-blue-500 bg-white hover:bg-blue-50 rounded-md transition-colors border border-gray-200 shadow-sm"
                        title="Sao chép nội dung"
                      >
                        <FiCopy className="w-4 h-4" />
                      </button>
                    </div>
                    )}
                    </>
                  )}

                  {/* Zalo Article Preview */}
                  {contentPlatform === "zalo" && zaloArticle && !isEditMode && (
                    <div className="mb-6 border border-blue-200 rounded-lg overflow-hidden">
                      <div className="bg-blue-50 px-4 py-2.5 border-b border-blue-200">
                        <h3 className="text-sm font-semibold text-blue-800 flex items-center">
                          <span className="mr-2 font-bold text-blue-600">Z</span>
                          Cấu trúc Zalo OA Article
                        </h3>
                      </div>
                      <div className="p-4 space-y-4">
                        {/* Title */}
                        <div className="relative">
                          <div className="flex justify-between items-center mb-1">
                            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">
                              Tiêu đề
                            </label>
                            <span className={`text-xs ${(zaloArticle.title || "").length > 150 ? "text-red-500 font-bold" : "text-gray-400"}`}>
                              {(zaloArticle.title || "").length}/150
                            </span>
                          </div>
                          <div className="relative">
                            <textarea
                              className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-base font-semibold focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                              rows="2"
                              value={zaloArticle.title || ""}
                              onChange={(e) =>
                                setZaloArticle((prev) => ({
                                  ...prev,
                                  title: e.target.value,
                                }))
                              }
                            />
                            <button
                              onClick={() => copyContent(zaloArticle.title, "tiêu đề")}
                              className="absolute top-2 right-2 p-1.5 text-gray-400 hover:text-blue-500 bg-white hover:bg-blue-50 rounded-md transition-colors border border-gray-100 shadow-sm"
                              title="Sao chép tiêu đề"
                            >
                              <FiCopy className="w-4 h-4" />
                            </button>
                          </div>
                        </div>

                        {/* Description */}
                        <div className="relative">
                          <div className="flex justify-between items-center mb-1">
                            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">
                              Mô tả
                            </label>
                            <span className={`text-xs ${(zaloArticle.description || "").length > 300 ? "text-red-500 font-bold" : "text-gray-400"}`}>
                              {(zaloArticle.description || "").length}/300
                            </span>
                          </div>
                          <div className="relative">
                            <textarea
                              className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                              rows="3"
                              value={zaloArticle.description || ""}
                              onChange={(e) =>
                                setZaloArticle((prev) => ({
                                  ...prev,
                                  description: e.target.value,
                                }))
                              }
                            />
                            <button
                              onClick={() => copyContent(zaloArticle.description, "mô tả")}
                              className="absolute top-2 right-2 p-1.5 text-gray-400 hover:text-blue-500 bg-white hover:bg-blue-50 rounded-md transition-colors border border-gray-100 shadow-sm"
                              title="Sao chép mô tả"
                            >
                              <FiCopy className="w-4 h-4" />
                            </button>
                          </div>
                        </div>

                        {/* Body - Single textarea for all content */}
                        <div className="relative">
                          <div className="flex justify-between items-center mb-1">
                            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">
                              Nội dung bài viết
                            </label>
                            <span className="text-xs text-gray-400">
                              {(zaloArticle.bodyParagraphs || []).join("\n\n").length} ký tự
                            </span>
                          </div>
                          <div className="relative">
                            <textarea
                              className="w-full px-3 py-2 pr-10 border border-gray-200 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 leading-relaxed"
                              rows={Math.max(6, (zaloArticle.bodyParagraphs || []).length * 3)}
                              value={(zaloArticle.bodyParagraphs || []).join("\n\n")}
                              onChange={(e) => {
                                const paragraphs = e.target.value.split(/\n\n+/).filter(Boolean);
                                setZaloArticle((prev) => ({
                                  ...prev,
                                  bodyParagraphs: paragraphs.length > 0 ? paragraphs : [""],
                                }));
                                setEditedPostText(e.target.value);
                                setHasEdited(true);
                              }}
                            />
                            <button
                              onClick={() => copyContent((zaloArticle.bodyParagraphs || []).join("\n\n"), "nội dung")}
                              className="absolute top-2 right-2 p-1.5 text-gray-400 hover:text-blue-500 bg-white hover:bg-blue-50 rounded-md transition-colors border border-gray-100 shadow-sm"
                              title="Sao chép nội dung"
                            >
                              <FiCopy className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {!allowNoImage && imageSource === "upload" ? (
                    <div className="mt-4">
                      <div className="flex justify-between items-center mb-3">
                        <h3 className="text-md font-medium">
                          Ảnh đã tải lên ({selectedImages.length}/9)
                        </h3>
                        <button
                          onClick={() => {
                            setSelectedImages([]);
                            setGeneratedPost((prevPost) => ({
                              ...prevPost,
                              images: [],
                            }));
                          }}
                          className="text-sm text-red-500 hover:text-red-700 font-medium"
                        >
                          Xóa tất cả
                        </button>
                      </div>
                      <div className="grid grid-cols-2 gap-3">
                        {selectedImages.map((image, index) => (
                          <div
                            key={index}
                            className="relative rounded-md overflow-hidden"
                          >
                            <img
                              src={image}
                              className="w-full h-40 object-cover bg-gray-100"
                              alt={`Ảnh đã tải lên ${index + 1}`}
                            />
                            <button
                              onClick={() => {
                                const newImages = [...selectedImages];
                                newImages.splice(index, 1);
                                setSelectedImages(newImages);
                                setGeneratedPost((prevPost) => ({
                                  ...prevPost,
                                  images: newImages,
                                }));
                              }}
                              className="absolute top-2 right-2 bg-gray-800 bg-opacity-60 hover:bg-opacity-80 text-white p-1.5 rounded-full"
                              title="Xóa ảnh"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openUploadedImagePreview(index);
                              }}
                              className="absolute top-2 left-2 bg-gray-800 bg-opacity-50 hover:bg-opacity-70 text-white p-1.5 rounded-full"
                              title="Xem ảnh"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                <path
                                  fillRule="evenodd"
                                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : !allowNoImage &&
                    imageSource === "internet" &&
                    serperImages && serperImages.length > 0 ? (
                    <div className="mt-6">
                      <div className="flex justify-between items-center mb-3">
                        <h3 className="text-md font-medium">
                          Ảnh đã chọn: {selectedSerperImages.length}/9
                        </h3>
                        {selectedSerperImages.length > 0 && (
                          <div className="flex gap-3">
                            <button
                              onClick={() => {
                                const remainingSlots =
                                  4 - selectedImages.length;
                                if (remainingSlots <= 0) {
                                  toast.warning(
                                    "Đã đạt giới hạn 4 ảnh. Vui lòng xóa bớt ảnh đã tải lên trước khi thêm mới."
                                  );
                                  return;
                                }
                                const imagesToAdd = selectedSerperImages.slice(
                                  0,
                                  remainingSlots
                                );
                                const newImages = imagesToAdd.filter(
                                  (imgUrl) => !selectedImages.includes(imgUrl)
                                );
                                if (newImages.length > 0) {
                                  setSelectedImages((prevImages) => [
                                    ...prevImages,
                                    ...newImages,
                                  ]);
                                  setGeneratedPost((prevPost) => ({
                                    ...prevPost,
                                    images: [
                                      ...(prevPost?.images || []),
                                      ...newImages,
                                    ],
                                  }));
                                  toast.success(
                                    `Đã thêm ${newImages.length} ảnh vào danh sách`
                                  );
                                } else {
                                  toast.info(
                                    "Tất cả ảnh đã có trong danh sách"
                                  );
                                }
                              }}
                              className="text-sm text-blue-600 hover:text-blue-800 font-medium"
                            >
                              Thêm vào ảnh đã tải lên
                            </button>
                            <button
                              onClick={() => setSelectedSerperImages([])}
                              className="text-sm text-red-500 hover:text-red-700 font-medium"
                            >
                              Bỏ chọn tất cả
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-2 gap-3">
                        {serperImages.map((img, index) => (
                          <div
                            key={index}
                            className="relative rounded-md overflow-hidden"
                          >
                            <img
                              src={img.imageUrl}
                              onClick={() => {
                                setSelectedSerperImages((prev) => {
                                  if (prev.includes(img.imageUrl)) {
                                    return prev.filter(
                                      (url) => url !== img.imageUrl
                                    );
                                  }
                                  if (prev.length >= 9) {
                                    toast.warning(
                                      "Đã đạt giới hạn 9 ảnh. Vui lòng bỏ chọn ảnh khác trước khi thêm mới."
                                    );
                                    return prev;
                                  }
                                  return [...prev, img.imageUrl];
                                });
                              }}
                              className={`w-full h-40 object-cover cursor-pointer ${
                                selectedSerperImages.includes(img.imageUrl)
                                  ? "ring-4 ring-blue-500"
                                  : "hover:opacity-90"
                              }`}
                              alt="Gợi ý ảnh"
                              onError={(e) => {
                                handleImageError(img.imageUrl);
                                e.target.parentNode.style.display = "none";
                              }}
                            />
                            {selectedSerperImages.includes(img.imageUrl) && (
                              <div className="absolute top-2 left-2 bg-blue-600 text-white rounded-md px-2 py-1 text-sm font-bold">
                                {selectedSerperImages.indexOf(img.imageUrl) + 1}
                              </div>
                            )}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openImagePreview(img.imageUrl);
                              }}
                              className="absolute top-2 right-2 bg-gray-800 bg-opacity-50 hover:bg-opacity-70 text-white p-1.5 rounded-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                <path
                                  fillRule="evenodd"
                                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : !allowNoImage &&
                    imageSource === "ai" &&
                    geminiGeneratedImage ? (
                    <div className="mt-6">
                      <div className="flex justify-between items-center mb-3">
                        <h3 className="text-md font-medium">
                          ✨ Ảnh AI đã tạo
                        </h3>
                        <button
                          onClick={() =>
                            generateGeminiImage(
                              generatedPost.title || generatedPost.text,
                              generatedPost.imagePrompt || ""
                            )
                          }
                          disabled={isRegeneratingImage}
                          className="text-sm text-purple-600 hover:text-purple-800 font-medium flex items-center"
                        >
                          <FiRefreshCw
                            className={`mr-1 ${
                              isRegeneratingImage ? "animate-spin" : ""
                            }`}
                            size={14}
                          />
                          {isRegeneratingImage
                            ? imageJobProgress > 0
                              ? `Đang tạo lại... ${imageJobProgress}%`
                              : "Đang tạo lại..."
                            : "Tạo lại ảnh AI"}
                        </button>
                      </div>
                      {isRegeneratingImage && imageJobStatus && (
                        <p className="text-sm text-purple-700 mb-3">
                          {imageJobMessage ||
                            `Đang tạo ảnh AI... ${imageJobProgress}%`}
                        </p>
                      )}
                      <div className="relative rounded-lg overflow-hidden border-2 border-purple-200 bg-purple-50">
                        <img
                          src={geminiGeneratedImage}
                          className="w-full object-contain max-h-96 cursor-pointer"
                          alt="Ảnh AI đã tạo"
                          onClick={() => openImagePreview(geminiGeneratedImage)}
                          onError={(e) => {
                            e.target.src = "";
                            toast.error("Không thể tải ảnh AI. Vui lòng tạo lại.");
                          }}
                        />
                        <div className="absolute top-2 left-2 bg-purple-600 text-white rounded-md px-2 py-1 text-xs font-bold flex items-center">
                          ✨ AI Generated
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            openImagePreview(geminiGeneratedImage);
                          }}
                          className="absolute top-2 right-2 bg-gray-800 bg-opacity-50 hover:bg-opacity-70 text-white p-1.5 rounded-full"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                            <path
                              fillRule="evenodd"
                              d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ) : null}

                  {/* Hiển thị khung tải lên ảnh nếu nguồn ảnh là upload hoặc chưa có ảnh nào (và không phải text-only) */}
                  {!allowNoImage &&
                  (imageSource === "upload" ||
                    (!generatedPost.image &&
                      !geminiGeneratedImage &&
                      serperImages.length === 0)) ? (
                    <div
                      className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-md p-6 cursor-pointer hover:border-blue-500 transition-colors mt-6"
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                      onClick={handleUploadClick}
                    >
                      <FiUploadCloud className="text-gray-400 text-4xl mb-2" />
                      <p className="text-gray-600 text-center font-medium">
                        {selectedImages.length > 0
                          ? `Kéo & thả ảnh vào đây, hoặc nhấn để tải thêm ảnh (${selectedImages.length}/9)`
                          : "Kéo & thả ảnh vào đây, hoặc nhấn để tải ảnh từ thiết bị"}
                      </p>
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleImageUpload}
                        className="hidden"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  ) : null}

                  {/* Hiển thị nút tạo ảnh cho nguồn internet nếu chưa có ảnh nhưng đã có bài viết (và không phải text-only) */}
                  {!allowNoImage &&
                    imageSource === "internet" &&
                    (!serperImages || serperImages.length === 0) &&
                    generatedPost?.text && (
                      <div className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-md p-6 mt-6">
                        <button
                          onClick={() =>
                            fetchImagesFromSerper(generatedPost.text)
                          }
                          disabled={isRegeneratingImage}
                          className={`w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium flex items-center justify-center ${
                            isRegeneratingImage
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          <FiRefreshCw
                            className={`mr-2 ${
                              isRegeneratingImage ? "animate-spin" : ""
                            }`}
                          />
                          {isRegeneratingImage
                            ? "Đang tìm ảnh..."
                            : "Tìm ảnh từ internet"}
                        </button>
                        <p className="text-gray-500 text-sm mt-2 text-center">
                          Tìm ảnh phù hợp với nội dung bài viết từ internet
                        </p>
                      </div>
                    )}

                  {/* Nút tạo ảnh AI khi chưa có ảnh nhưng đã có bài viết */}
                  {!allowNoImage &&
                    imageSource === "ai" &&
                    (!geminiGeneratedImage || geminiGeneratedImage === "") &&
                    generatedPost?.text && (
                      <div className="flex flex-col items-center justify-center border-2 border-dashed border-purple-300 rounded-md p-6 mt-6 bg-purple-50">
                        <button
                          onClick={() =>
                            generateGeminiImage(
                              generatedPost.title || generatedPost.text,
                              generatedPost.imagePrompt || ""
                            )
                          }
                          disabled={isRegeneratingImage}
                          className={`w-full bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-md font-medium flex items-center justify-center ${
                            isRegeneratingImage
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          <FiRefreshCw
                            className={`mr-2 ${
                              isRegeneratingImage ? "animate-spin" : ""
                            }`}
                          />
                          {isRegeneratingImage
                            ? imageJobProgress > 0
                              ? `Đang tạo ảnh AI... ${imageJobProgress}%`
                              : "Đang tạo ảnh AI..."
                            : "Tạo ảnh bằng AI"}
                        </button>
                        <p className="text-gray-500 text-sm mt-2 text-center">
                          {isRegeneratingImage && imageJobMessage
                            ? imageJobMessage
                            : "Tạo ảnh AI dựa trên tiêu đề bài viết"}
                        </p>
                      </div>
                    )}
                </div>

                <div className="flex flex-col gap-4"></div>

                {/* User-friendly report reminder and Zalo contact */}
                <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      <FiFlag className="h-4 w-4 text-orange-600 mr-2" />
                      <span className="text-sm text-orange-800">
                        <strong>Không hài lòng với bài viết?</strong>
                      </span>
                    </div>
                    <button
                      onClick={openReportModal}
                      className="text-sm text-orange-700 hover:text-orange-900 underline font-medium"
                    >
                      Báo cáo ngay
                    </button>
                  </div>
                  <p className="text-xs text-orange-600 mb-3 ml-6">
                    Giúp chúng tôi cải thiện AI tạo nội dung tốt hơn cho bạn
                  </p>

                  {/* Zalo Support Contact */}
                  <div className="pt-3 border-t border-orange-200">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="w-4 h-4 mr-2 flex items-center justify-center">
                          <span className="text-sm">💬</span>
                        </div>
                        <span className="text-sm text-orange-800">
                          <strong>Cần hỗ trợ trực tiếp?</strong>
                        </span>
                      </div>
                      <a
                        href="https://zalo.me/0394932696"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors duration-200 shadow-sm hover:shadow-md"
                      >
                        <svg
                          className="w-4 h-4 mr-1.5"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                        </svg>
                        Zalo hỗ trợ
                      </a>
                    </div>
                    <p className="text-xs text-orange-600 mt-1 ml-6">
                      Liên hệ ngay để được tư vấn và hỗ trợ 1:1
                    </p>
                  </div>
                </div>

                <div className="mt-0 space-y-2">
                  <button
                    onClick={publishPost}
                    className="flex items-center justify-center w-full gap-2 bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 font-medium"
                    disabled={isPublishing || selectedFanpages.length === 0}
                  >
                    {isPublishing ? (
                      <ClipLoader size={20} color={"#fff"} />
                    ) : (
                      <FiSend />
                    )}
                    {isPublishing ? "Đang đăng bài..." : "Đăng bài viết"}
                  </button>
                  <button
                    onClick={() => setShowScheduleModal(true)}
                    className="flex items-center justify-center w-full gap-2 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium"
                    disabled={isPublishing || isScheduling || selectedFanpages.length === 0}
                  >
                    <FiClock />
                    Lên lịch đăng bài
                  </button>
                  {selectedFanpages.length === 0 && (
                    <p className="text-red-500 text-sm mt-2 text-center">
                      Vui lòng chọn ít nhất một {contentPlatform === "zalo" ? "tài khoản Zalo OA" : "Fanpage"} để đăng bài
                    </p>
                  )}
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-md shadow-md p-5 h-full flex flex-col items-center justify-center text-center">
                <div className="text-gray-400 mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-16 w-16 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">
                  Chưa có bài viết nào
                </h3>
                <p className="text-gray-500 mb-6">
                  Nhập yêu cầu bài viết HOẶC URL tham khảo và nhấn "Tạo bài
                  viết" để bắt đầu
                </p>
                <button
                  onClick={suggestTopics}
                  disabled={isSuggestingTopics}
                  className="flex items-center justify-center bg-blue-50 text-blue-600 py-2 px-4 rounded-md hover:bg-blue-100 transition-colors font-medium"
                >
                  <FiRefreshCw
                    className={`mr-2 ${
                      isSuggestingTopics ? "animate-spin" : ""
                    }`}
                  />
                  {isSuggestingTopics ? "Đang gợi ý..." : "Hoặc gợi ý chủ đề"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Danh sách bài viết đã lên lịch */}
      <ScheduledPostsList />

      {previewImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
          onClick={closeImagePreview}
        >
          <div className="relative max-w-4xl w-full h-full p-4 flex items-center justify-center">
            {/* Previous button */}
            <button
              onClick={handlePrevImage}
              className="absolute left-6 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full z-10"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            {/* Next button */}
            <button
              onClick={handleNextImage}
              className="absolute right-6 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full z-10"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>

            {/* Close button */}
            <button
              onClick={closeImagePreview}
              className="absolute top-6 right-6 text-white hover:text-gray-300 z-10"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Image */}
            <img
              src={previewImage}
              alt="Preview"
              className="max-h-full max-w-full object-contain"
              onClick={(e) => e.stopPropagation()}
              onError={(e) => {
                toast.error(
                  "Không thể tải ảnh xem trước. Hình ảnh có thể không khả dụng.",
                  {
                    position: "top-right",
                    autoClose: 3000,
                  }
                );
                closeImagePreview();
              }}
            />

            {/* Image counter */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-50 px-3 py-1 rounded-full">
              {currentImageIndex + 1} /{" "}
              {previewImage && selectedImages.includes(previewImage)
                ? selectedImages.length
                : validSerperImages.length}
            </div>
          </div>
        </div>
      )}
      <ToastContainer />

      {/* Modal kết nối lại fanpage */}
      <ReconnectFanpageModal
        isOpen={showReconnectModal}
        onClose={() => setShowReconnectModal(false)}
        fanpage={reconnectFanpage}
        onReconnect={handleReconnectFanpage}
      />

      {/* Report Modal */}
      {showReportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-5 border-b border-gray-200">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                  <FiFlag className="mr-2 text-orange-600" />
                  Báo cáo lỗi bài viết
                </h3>
                <p className="text-sm text-gray-500 mt-1">
                  Giúp chúng tôi cải thiện chất lượng bài viết
                </p>
              </div>
              <button
                onClick={closeReportModal}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <FiX size={20} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-5">
              {/* Quick Report Types */}
              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Chọn loại lỗi: <span className="text-red-500">*</span>
                </label>
                <div className="grid gap-2">
                  {reportTypes.map((type) => (
                    <button
                      key={type.value}
                      onClick={() => setReportType(type.value)}
                      className={`p-3 text-left rounded-lg border-2 transition-all ${
                        reportType === type.value
                          ? "border-orange-500 bg-orange-50 text-orange-900"
                          : "border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      <span className="text-sm font-medium">{type.label}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Additional Description */}
              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Mô tả chi tiết (tùy chọn):
                </label>
                <textarea
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 resize-none"
                  rows="3"
                  value={reportDescription}
                  onChange={(e) => setReportDescription(e.target.value)}
                  placeholder="Mô tả thêm về lỗi để chúng tôi cải thiện tốt hơn..."
                  maxLength={500}
                />
                <div className="text-xs text-gray-400 mt-1 text-right">
                  {reportDescription.length}/500 ký tự
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex gap-3 p-5 border-t border-gray-200">
              <button
                onClick={closeReportModal}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors font-medium"
                disabled={isSubmittingReport}
              >
                Hủy
              </button>
              <button
                onClick={handleReportSubmit}
                disabled={!reportType || isSubmittingReport}
                className="flex-1 px-4 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium flex items-center justify-center"
              >
                {isSubmittingReport ? (
                  <>
                    <ClipLoader size={16} color="#ffffff" className="mr-2" />
                    Đang gửi...
                  </>
                ) : (
                  <>
                    <FiSend className="mr-2" size={16} />
                    Gửi báo cáo
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Schedule Post Modal */}
      <SchedulePostModal
        isOpen={showScheduleModal}
        onClose={() => setShowScheduleModal(false)}
        onConfirm={schedulePost}
        isScheduling={isScheduling}
      />

      {showUpgradeModal && (
        <div className="fixed inset-0 z-[70] bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all duration-300 scale-100">
            <div className="p-6">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-4 mx-auto text-amber-600 text-2xl">
                ⚠️
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                Yêu cầu nâng cấp gói dịch vụ!
              </h3>
              <p className="text-sm text-gray-600 mb-6 text-center leading-relaxed">
                Tính năng <strong>Tạo ảnh bằng AI tự động</strong> chỉ khả dụng từ gói <strong>Cao Cấp</strong> trở lên. Gói hiện tại của bạn chưa hỗ trợ tính năng này.
                <br /><br />
                Nâng cấp lên gói Cao Cấp để mở khóa tạo ảnh AI tự động không giới hạn cho bài viết, tích hợp đăng bài tự động lên Website WordPress và nhiều đặc quyền VIP khác!
              </p>
              <div className="flex flex-col gap-2">
                <button
                  type="button"
                  onClick={() => {
                    setShowUpgradeModal(false);
                    navigate("/pricing");
                  }}
                  className="w-full px-4 py-2.5 text-sm font-semibold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors shadow-lg shadow-blue-200 text-center"
                >
                  🚀 Nâng cấp ngay
                </button>
                <button
                  type="button"
                  onClick={() => setShowUpgradeModal(false)}
                  className="w-full px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors text-center"
                >
                  Để sau
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NormalPostGenerator;
